$(document).ready(function() {
    // Shop by  Color Toggle 
    $(document).on("click", ".shop-group-title .arrow", function(e) {
        e.preventDefault();
        let $this = $(this);
        $this.toggleClass('active');
        $this.parents('.color_tab').find('.shop-group-title').toggleClass('active-tab');
        $this.parents('.color_tab').find('.shop-group-color').slideToggle(350);
    });

    // PLP COlor Toogle in filter section
    $(document).on("click", ".color-group--item", function(e) {
        $('.color-group--item').removeClass('active');
        $(this).addClass('active');
    });

    // add class for Safari Browser
    if(navigator.platform == 'MacIntel'){
        $('body').addClass('safari_browser');
    }    

    var related_array_id = [];
    $(".related_pro_item").each(function(index) {
        related_array_id.push($(this).attr('data-product_id'));
    });
    
    if (related_array_id.length > 0) {
        $('.inventory_loader').css('display', 'flex');
    }

    // add classes to high stock items to get filter
    function FilterHighStockItems() {

        let productAvailability = {};
        $(".related_pro_item .meta_product_inventory .variant_total_qty").each(function(index) {
            const pro_id = $(this).parents('.related_pro_item').attr('data-product_id');
            const available_qty = parseInt($(this).text());

            // Initialize product availability if not already set
            if (!(pro_id in productAvailability)) {
                productAvailability[pro_id] = false;
            }

            // Check if the current available_qty is above 1000
            if (available_qty > 1000) {
                productAvailability[pro_id] = true;
            }
        });

        $(".related_pro_item").each(function() {
            var high_stock1000 = false;
            var high_stockCal = false;
            var current_high_stock = $(this);        

            $(this).find('.qty_main_califonia  .meta_product_inventory').each(function() {
                const qtyValue = $(this).find('.variant_total_qty').html();
            
                if (qtyValue > 1000) {
                    high_stockCal = true;
                }
               
                if(high_stockCal == true){                
                    current_high_stock.find('.qty_main_califonia').addClass('highstocklocation'); 
                    current_high_stock.find('.location_title[data-location_title="california"]').addClass('highstocklocationtitle');
                    current_high_stock.find('.location_califonia_subtotal').addClass('highstockloc_price');
                    return false ;  
                }
            });

            $(this).find('.qty_main_alabama  .meta_product_inventory').each(function() {
                const qtyValue = $(this).find('.variant_total_qty').html();
            
                if (qtyValue > 1000) {
                    high_stock1000 = true;
                }
                
                if(high_stock1000 == true){                
                    current_high_stock.find('.qty_main_alabama').addClass('highstocklocation');
                    current_high_stock.find('.location_title[data-location_title="alabama"]').addClass('highstocklocationtitle');
                    current_high_stock.find('.location_alabma_subtotal').addClass('highstockloc_price');
                    return false ;  
                }
            });
        });

        // Loop through productAvailability object and add class accordingly
        Object.keys(productAvailability).forEach(function(pro_id) {
            if (productAvailability[pro_id]) {
                $('.related_pro_item[data-product_id = ' + pro_id + ']').addClass('high_stock_item');
            }else{
              $('.related_pro_item[data-product_id = ' + pro_id + ']').addClass('notHightStockItem');
            }
        });
    }
    
    var pack_qty = $('.inventory_table_header').data('pack-qty');  
    if(window.location.href.indexOf("products") > -1){
      // get inventory related products from PHP API and create table layout 
      $.ajax({
          type: 'POST',
          url: 'https://nla-promodash.westus.cloudapp.azure.com/NLA_PDP_LOGIC.php',
          data: {
              "product_id": related_array_id
          },
          success: function(data) {
            
              $('.location_inventory_main').css('display', 'block');
              $('.inventory_loader').css('display', 'none');
              const inventory_get_array = JSON.parse(data);
              const keys = inventory_get_array.map(item => Object.keys(item)[0]);
  
              var product_sizes = [];
              var sizes = [];
              var product_case_qty = [];
              var unique_product_handle = '';
             
            // Initialize NotifyMe work
            function showError(elementId, message) {
                const $element = $('#' + elementId);
                const $errorSpan = $element.next('.error');
                
                if ($errorSpan.length) {
                    $errorSpan.text(message);
                } else {
                    $element.after(`<span class="error">${message}</span>`);
                }
                $element.addClass('error').removeClass('valid');
            }

            function hideError(elementId) {
                const $element = $('#' + elementId);
                $element.next('.error').remove();
                $element.removeClass('error').addClass('valid');
            }

            function validateForm() {
                let isValid = true;

                // Clear all existing errors
                $('.error').remove();
                $('.error').removeClass('error');

                // Validate location
                const location = $('#locationDropdown').val();
                if (!location) {
                    showError('locationDropdown', 'Please select a location');
                    isValid = false;
                } else {
                    hideError('locationDropdown');
                }

                // Validate color (only if location is selected)
                const color = $('#color_Dropdown').val();
                if (location && !color) {
                    showError('color_Dropdown', 'Please select a color');
                    isValid = false;
                } else if (location && color) {
                    hideError('color_Dropdown');
                }

                // Validate size (only if color is selected)
                const size = $('#sizeDropdown').val();
                if (color && !size) {
                    showError('sizeDropdown', 'Please select a size');
                    isValid = false;
                } else if (color && size) {
                    hideError('sizeDropdown');
                }

                // Validate email (only if size is selected)
                const email = $('#emailInput').val();
                const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                
                if (size && $('#emailSection').is(':visible')) {
                    if (!email) {
                        showError('emailInput', 'Please enter your email address');
                        isValid = false;
                    } else if (!emailRegex.test(email)) {
                        showError('emailInput', 'Please enter a valid email address');
                        isValid = false;
                    } else {
                        hideError('emailInput');
                    }
                }

                return isValid;
            }
            // populateLocationDropdown
               // Location mapping
              
            const locationMapping = {
                "96169984303": "California",
                "96170017071": "Alabama"
            };
            
            const firstEntry = Object.keys(locationMapping)[0];
            const secondEntry = Object.keys(locationMapping)[0];
            const check_california_stock = checkLocationStock(firstEntry);
            const check_alabama_stock = checkLocationStock(secondEntry);
           
             // Hide if all product stock available
             if(check_california_stock == false && check_alabama_stock == false){
                      $('#notifyme').hide();
              }

            const $locationDropdown = $('#locationDropdown');
            const locations = new Set();

                // Clear existing options except the first one
                $locationDropdown.html('<option value="">Select a location...</option>');

                // Extract unique locations from JSON data
                
                $.each(inventory_get_array, function(index, product) {
                    $.each(product, function(productId, variants) {
                        $.each(variants, function(index, item) {
                            locations.add(item.location_id);
                           });
                    });
                });

                // Add location options to dropdown
              
                locations.forEach(function(locationId) {
                    const locationName = locationMapping[locationId] || `Location ${locationId}`;
                    $locationDropdown.append(`<option value="${locationId}">${locationName}</option>`);
                });
                
               // console.log('Location dropdown ', Array.from(locations));
              // Location dropdown change event
            $('#locationDropdown').on('change', function() {
                const selectedLocation = $(this).val();
                const $color_Dropdown = $('#color_Dropdown');
                const $sizeDropdown = $('#sizeDropdown');

                // Clear validation errors when location changes
                 $('#result').html("").hide();
                hideError('locationDropdown');
                hideError('color_Dropdown');
                hideError('sizeDropdown');
                hideError('emailInput');

                if (selectedLocation) {
                    populateColorDropdownForLocation(selectedLocation);
                    $color_Dropdown.prop('disabled', false);
                    // Reset size dropdown
                    $sizeDropdown.prop('disabled', true);
                    $sizeDropdown.html('<option value="">Select color first...</option>');
                    hideEmailSection();
                } else {
                    $color_Dropdown.prop('disabled', true);
                    $color_Dropdown.html('<option value="">Select location first...</option>');
                    $sizeDropdown.prop('disabled', true);
                    $sizeDropdown.html('<option value="">Select color first...</option>');
                    hideEmailSection();
                }
            });
             function checkLocationStock(locationId) {
                let hasOutOfStock = false;
             // Check all products for this location
                $.each(inventory_get_array, function(index, product) {
                    $.each(product, function(productId, variants) {
                        $.each(variants, function(index, item) {
                            if (item.location_id === locationId) {
                                if (item.available_qty === 0) {
                                    hasOutOfStock = true;
                                }
                            }
                        });
                    });
                });
                
                return hasOutOfStock;
            }
            function populateColorDropdownForLocation(selectedLocationId) {
                const $color_Dropdown = $('#color_Dropdown');
                const productIds = new Set();

                // Clear existing options
                $color_Dropdown.html('<option value="">Select a color...</option>');

                // Extract unique product IDs for colors
                $.each(inventory_get_array, function(index, product) {
                    $.each(product, function(productId, variants) {
                        const hasZeroQtyForLocation = variants.some(function(item) {
                            
                             if(item.location_id === selectedLocationId && item.available_qty === 0){
                              //  alert(JSON.stringify(item));
                              return true;
                             }
                            //return item.location_id === selectedLocationId && item.available_qty === 0;
                        });
                       
                        if (hasZeroQtyForLocation) {
                           // alert("LocationID:"+ selectedLocationId + " , Prod : "+productId);
                            var check_dnr_product = $('[data-product_id="'+productId+'"] .product-new-badge .dnr_prod');
                            
                            if(check_dnr_product.length == 0){
                            productIds.add(productId);
                            }
                           
                        }
                    });
                });
                
                // Add color options
                let colorIndex = 0;
                 
                Array.from(productIds).sort().forEach(function(productId) {
                 // alert("productId" + productId);
                    var target_prod_color = $('.related_pro_item[data-product_id="'+productId+'"] .variant_inventories').attr("data-product_title");
                 //   alert(target_prod_color);
                    $color_Dropdown.append(`<option value="${productId}">${target_prod_color}</option>`);
                    colorIndex++;
                });

            }

            // Color dropdown change event
            $('#color_Dropdown').on('change', function() {
                const selectedLocation = $('#locationDropdown').val();
                const selectedColor = $(this).val();
                const $sizeDropdown = $('#sizeDropdown');

                // Clear validation errors when color changes
                 $('#result').html("").hide();
                hideError('color_Dropdown');
                hideError('sizeDropdown');
                hideError('emailInput');
                  hideEmailSection();   
                if (selectedColor && selectedLocation) {
                    populateSizeDropdownForLocationAndColor(selectedLocation, selectedColor);
                    $sizeDropdown.prop('disabled', false);
                } else {
                    $sizeDropdown.prop('disabled', true);
                    $sizeDropdown.html('<option value="">Select color first...</option>');
                   
                }
            });

            function populateSizeDropdownForLocationAndColor(selectedLocationId, selectedProductId) {
                const $sizeDropdown = $('#sizeDropdown');
                const sizesForLocationAndColor = new Map();

                // Clear existing options
                $sizeDropdown.html('<option value="">Select a size...</option>');

                // Find variant names where available_qty = 0 for the selected location and product
                $.each(inventory_get_array, function(index, product) {
                    if (product[selectedProductId]) {
                        $.each(product[selectedProductId], function(index, item) {
                            if (item.available_qty === 0 && item.location_id === selectedLocationId) {
                                sizesForLocationAndColor.set(item.variant_name, item.variant_id);
                            }
                        });
                    }
                });

                // Sort sizes in logical order
                const sizeOrder = ['XS', 'S', 'M', 'L', 'XL', '2XL', '3XL', '4XL', '5XL', '6XL', '7XL'];
                const sortedSizes = Array.from(sizesForLocationAndColor.keys()).sort(function(a, b) {
                    return sizeOrder.indexOf(a) - sizeOrder.indexOf(b);
                });

                // Add size options to dropdown
                sortedSizes.forEach(function(size) {
                    const variantId = sizesForLocationAndColor.get(size);
                    $sizeDropdown.append(`<option value="${variantId}" data-size="${size}">${size}</option>`);
                });

                console.log('Size dropdown populated:', sortedSizes);
            }
             // Size dropdown change event
            $('#sizeDropdown').on('change', function() {
                // Clear validation errors when size changes
                hideError('sizeDropdown');
                hideError('emailInput');
                 $('#result').html("").hide();
                if ($(this).val()) {
                    showEmailSection();
                } else {
                    hideEmailSection();
                }
            });
            function showEmailSection() {
                $('#emailSection').show();
                $('#submitButton').show();
            }

            function hideEmailSection() {
                $('#emailSection').hide();
                $('#submitButton').hide();
            }

            // Email input event for real-time validation
            $('#emailInput').on('input blur', function() {
                const email = $(this).val();
                const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                
                if (email && !emailRegex.test(email)) {
                    showError('emailInput', 'Please enter a valid email address');
                } else if (email) {
                    hideError('emailInput');
                }
            });

             // Submit button click event
            $('#submitButton').on('click', function(e) {
                e.preventDefault();
                $('#result').html("").hide();
                if (validateForm()) {
                    handleFormSubmission();
                }
            });

            function handleFormSubmission() {
                const selectedLocation = $('#locationDropdown').val();
                const selectedLocationName = $('#locationDropdown option:selected').text();
                const selectedColor = $('#color_Dropdown').val();
                const selectedColorName = $('#color_Dropdown option:selected').text();
                const selectedSizeVariantId = $('#sizeDropdown').val();
                const selectedSizeName = $('#sizeDropdown option:selected').data('size');
                const emailValue = $('#emailInput').val();
                const companyNameValue = $('#companyName').val();
                const customerIDValue = $('#customerID').val();
                // Create submission data
                const submissionData = {
                    location_id: selectedLocation,
                    location_name: selectedLocationName,
                    product_id: selectedColor,
                    color_name: selectedColorName,
                    variant_id: selectedSizeVariantId,
                    size: selectedSizeName,
                    email: emailValue,
                    company_name: companyNameValue,
                    customer_id: customerIDValue,
                    timestamp: new Date().toISOString()
                };

                
          $.ajax({
          type: 'POST',
          url: 'https://nla-locator.nextlevelapparel.com/backinstock/notifyme_api.php',
          data: {
              "notifyme": submissionData
          },
          success: function(data) {
            var dataJson = JSON.parse(data);
             // Show success message
                const resultHTML = dataJson.message;
                if(dataJson.status == 'exist' || dataJson.status == 'failed'){
                    $('#result').css('color','red');
                    $('#result').html(resultHTML).show();
                }else{
                      $('#result').html(resultHTML).show();
                       // Reset form
                        resetForm();
                }
                
          }
        });
               

               
            }


            function resetForm() {
              
                $('#locationDropdown').val('');
                $('#color_Dropdown').prop('disabled', true).html('<option value="">Select location first...</option>');
                $('#sizeDropdown').prop('disabled', true).html('<option value="">Select color first...</option>');
                hideEmailSection();
            }
              // End of NotifyMe work   

              inventory_get_array.forEach(item => {
              var product_id = Object.keys(item)[0];
  
                  $(".related_pro_item").each(function(index) {
                      var rel_pro = $(this).attr('data-product_id');
                      var current = $(this);
                      var main_prod_handle = $(this).attr('data-product_handle');
                      if (product_id == rel_pro) {                
                          $.each(item, function(key, value) {
                              $.each(value, function(inkey, invalue) {
                                  $.each(invalue, function(inventorykey, inventoryvalue) {                                
                                      if (inventorykey == 'available_qty') {
                                          var api_sizes_data = invalue.variant_name + " : " + invalue.price + " : " + main_prod_handle;
                                          var api_size_data = invalue.variant_name;                                        
                                          if ($.inArray(api_sizes_data, product_sizes) === -1) {
                                              // If not present, push it to the array                                        
                                              product_sizes.push(api_sizes_data);
                                          }
                                          if ($.inArray(api_size_data, sizes) === -1) {
                                              sizes.push(api_size_data);
                                          }
                                      }
                                  });
                              });
                          });
                      }
                  });



              });

			// Added to fix the pricing per color in grid
                 $(".related_pro_item").each(function(index) {
                      var rel_pro = $(this).attr('data-product_id');
                      var current = $(this);
                      var rel_product_handle = $(this).attr('data-product_handle');
                  
                   (async () => {
                      try {
                          const response = await fetch('https://www.nextlevelapparel.com/products/' + rel_product_handle + '.json')
                          if (!response.ok) {
                              throw new Error(`HTTP error! Status: ${response.status}`);
                          }
                          
                          response.json().then(data => 
            $.each(data.product.variants, function(index, value){
              
                $('.related_pro_item[data-product_handle = ' + rel_product_handle + '] .variant_loc_al .meta_product_inventory[data-variant_title = '+ value.title +']').each(function(index){
                    var variant_price = $(this).attr('data-variant_price');
                  var variant_id = $(this).attr('data-variant-id');
                  
                  //alert( value.title +" >> " + variant_id + " >> " + variant_price + " >> "+ value.price);
                    $(this).attr('data-variant_price', value.price);
                    $(this).find(".variant_grid_price").html("$"+value.price);
                }) 
             

              $('.related_pro_item[data-product_handle = ' + rel_product_handle + '] .variant_loc_cal .meta_product_inventory[data-variant_title = '+ value.title +']').each(function(index){
                    var variant_price = $(this).attr('data-variant_price');
                  var variant_id = $(this).attr('data-variant-id');
                  
                    $(this).attr('data-variant_price', value.price);
                  
                    
                })
            })
        ).catch(error => {
                              console.error('Error parsing JSON:', error);
                          });
                  
                      } catch (error) {
                          console.error('Error fetching data:', error);
                      }
                  })();

                   
                   
                 })
              
              // Define size hierarchy
              var sizeHierarchy = {'2XS': 0,'XS': 1,'S': 2,'M': 3,'L': 4,'XL': 5,'2XL': 6,'3XL': 7,'4XL': 8,'5XL': 9,'6XL': 10,'7XL': 11,'8XL': 12,'9XL': 13,'10XL': 14,'OS': 15,'2T': 16,'3T': 17,'4T': 18};
                  
              // Custom sort based on size hierarchy
              sizes.sort(function(a, b) {
                  return sizeHierarchy[a] - sizeHierarchy[b];
              });            
  
              // Parse sizes and prices into separate arrays
              var sizes_check = product_sizes.map(function(item) {               
                  return item.split(' : ')[0];
              });
  
              // Sort sizes array based on the order of sizesOrder
              sizes_check.sort(function(a, b) {
                  return sizes.indexOf(a) - sizes.indexOf(b);
              });
  
              // Create a new sorted sizesWithPrices array
              var sortedSizesWithPrices = sizes.map(function(size) {
                  return product_sizes.find(function(item) {
                      return item.startsWith(size);
                  });
              });
  
              let lastElement = sortedSizesWithPrices[sortedSizesWithPrices.length - 1]
              if(lastElement != undefined){
                  unique_product_handle = lastElement.split(' : ')[2]; 
                //  updatePrices(unique_product_handle);
              }
  
              if (product_sizes.length > 0) {
                  $('.qty_location_main').empty();
              } 
              if (product_sizes.length == 0) {
                  $('.location_inventory_main').hide();
              }
  
              var maxCaseSizeCount = 0;
              var handleWithMaxCount = "";
              
              $(".product_future_stock").each(function(index) {
                  var caseSizeCount = 0;
                  var handle = $(this).attr('data-handle');
                  
                  $(this).find(".case_variant_qty").each(function(index) {
                      caseSizeCount++;
                  });
                  
                  if (caseSizeCount > maxCaseSizeCount) {
                      maxCaseSizeCount = caseSizeCount;
                      handleWithMaxCount = handle;
                      var product_handle = $(this).attr('data-handle');
  
                      if(handleWithMaxCount == product_handle ){                        
                          $(this).find(".case_variant_qty").each(function(index) {
                              var variant_title = $(this).attr('data-variant');
                              var variant_case_qty = $(this).attr('data-case_qty');
                              var variant_parent_handle = $(this).parent().attr('data-handle');
                              var variant_case_qty_data = variant_title + " : " + variant_case_qty + " : " + variant_parent_handle;
                          
                              if ($.inArray(variant_case_qty_data, product_case_qty) === -1) {                 
                                  product_case_qty.push(variant_case_qty_data);
                              }
                          });
                      }
                  }
              });
  
              // Create an object to store sizes and quantities
              var sizeQtyMap = {};
  
              // Fill the object with quantities
              product_case_qty.forEach(function(sizeQty) {     
                  var [size, qty, handle] = sizeQty.split(" : ");
                  sizeQtyMap[size.trim()] = qty.trim();
              });
  
              // Update quantities in sizesAndPrices array
              sortedSizesWithPrices.forEach(function(sizePrice, index) {
                  var [size, price, handle] = sizePrice.split(" : ");
                  var qty = sizeQtyMap[size.trim()];
                  if (qty !== undefined) {
                      sortedSizesWithPrices[index] = size.trim() + " : " + price.trim() + " : " + qty + " : " + handle;
                  }
              });
  
              $.each(sortedSizesWithPrices, function(key, sizes) {                
                  var variant_title = sizes.split(' :')[0];
                  var variant_price = sizes.split(': ')[1];
                  var variant_qty = sizes.split(': ')[2].trim(); 

                  var variant_details = '<div class="variant_detail_items" data-size='+ variant_title +'><label class="size_opt_title">' + variant_title + '</label><label class="pack_size_qty text-sm" data-pack_qty="' + variant_qty + '">' + variant_qty + '</label><span class="variant_price text-sm"></span></div>'
                  $('#variant_sizes_main').append(variant_details);
                  
                   
                  var default_size_input = '<div class="meta_product_inventory no-quantity data-variant-title-'+ variant_title + '" data-pack-qty="' + variant_qty + '" data-variant-id="48828627550511" data-variant_location_id="96169984303" data-variant_title="' + variant_title + '" data-variant_price=""><label class="variant_grid_price"></label><input class="variant_qty_input" type="number" max="0" min="" step=""><span class="error_input_iventory text-xs"><label class="max_error">Please add quantity less than 0</label></span><br><label class="variant_total_qty">-</label></div>'
                  $('.qty_location_main').append(default_size_input);

                                       
              });
              
              var pack_qty_na_check =  $('.pack_size_qty').data('pack_qty');   
              var item_count = 0;
              var dnr_item_count = 0;
              inventory_get_array.forEach(item => {
                  var product_id = Object.keys(item)[0];
                  $(".related_pro_item").each(function(index) {
                      var rel_pro = $(this).attr('data-product_id');
                      var current = $(this);
                           
                      if (product_id == rel_pro) {
                        
                        var isDNR = false;
                         if (current.find(".dnr_prod").length > 0) {
                              isDNR = true;
                              dnr_item_count++;
                            }
                          $.each(item, function(key, value) {
                              $.each(value, function(inkey, invalue) {
                                  var location_title = '';
                                  var location_id = '';
                                  let variant_id = '';
                                  $.each(invalue, function(inventorykey, inventoryvalue) {
                                      if (inventorykey == 'available_qty') {
                                           var noquantity = false;
                                          if (invalue.available_qty == 0 || invalue.available_qty == null) {
                                         
                                              var classNoQuantity = 'no-quantity';
                                              noquantity = true;

                                          } else {
                                              var classNoQuantity = 'has-quantity';
                                          }                                    
                                          if(invalue.available_qty > 10000){
                                              var qty_left = '10000+';
                                              var org_qty = invalue.available_qty;
                                          }
                                          else{
                                              var qty_left = invalue.available_qty;
                                              var org_qty = invalue.available_qty;
                                          }
                                          if(qty_left == 0){
                                            qty_left = '-';
                                          }
                                          var notify_me_stock = '';
                                            if(noquantity == true && isDNR == false){
                                              
                                             notify_me_stock = '<span class="notify_me_stock" ><a href="javascript:void(0);" data-variant-id="" class="notifyme_grid_btn">Notify Me</a></span>';
                                              const parentDiv = $('.notify_me_stock').closest('.variant_inventory');
                                            /* if (parentDiv) {
                                              parentDiv.addClass('hasNotifyme'); 
                                            } */
                                            }
                                      
                                      
                                        var lowStock = '';
                                        var packqty = $('.data-variant-title-'+invalue.variant_name).data('pack-qty');
                                        if(org_qty < packqty){
                                          var lowStock = '<span class="low_stock" data-pack="'+packqty+'" >Low Stock</span>';
                                           const parentDiv = $('.low_stock').closest('.variant_inventory');
                                            if (parentDiv) {
                                              parentDiv.addClass('hasLowstock'); // Replace with the class you want to add
                                            }
                                         }
                                          var meta_item_inventory = '<label class="variant_grid_price"></label> <input class="variant_qty_input test" type="number" max="' + org_qty + '" data-org-qty="' + org_qty + '"><span class="error_input_iventory text-xs"><label class="multiple_error">Please add quantity in multiple of ' + pack_qty + '</label><label class="max_error">Please add quantity less than or equal to ' + inventoryvalue + '</label></span><br><label class="variant_total_qty" style="display:none">' + org_qty + '</label><label class="variant_total_qtys">' + qty_left + '</label>';
                                          var api_variant_title = invalue.variant_name;
                                          var api_sizes_data = invalue.variant_name + " : " + invalue.price;
  
                                          if ($.inArray(api_sizes_data, product_sizes) === -1) {
                                              // If not present, push it to the array
                                              product_sizes.push(api_sizes_data);
                                          }
  
                                          if (invalue.location_id == 96169984303) {                                            
                                              current.find('.variant_inventories .qty_main_califonia .meta_product_inventory[data-variant_title="' + api_variant_title + '"]').removeClass('no-quantity');
                                              current.find('.variant_inventories .qty_main_califonia .meta_product_inventory[data-variant_title="' + api_variant_title + '"]').addClass(classNoQuantity);
                                              current.find('.variant_inventories .qty_main_califonia .meta_product_inventory[data-variant_title="' + api_variant_title + '"]').attr('data-variant_location_id', invalue.location_id);
                                              if (!(invalue.available_qty == 0 || invalue.available_qty == null)) {
                                                 meta_item_inventory +=  lowStock;
                                                  current.find('.variant_inventories .qty_main_califonia .meta_product_inventory[data-variant_title="' + api_variant_title + '"]').attr('data-variant-id', invalue.variant_id);
                                                  current.find('.variant_inventories .qty_main_califonia .meta_product_inventory[data-variant_title="' + api_variant_title + '"]').attr('data-variant_price', invalue.price);
                                                  current.find('.variant_inventories .qty_main_califonia .meta_product_inventory[data-variant_title="' + api_variant_title + '"]').html(meta_item_inventory);
                                                  // current.find('.variant_inventories .qty_main_califonia .meta_product_inventory[data-variant_title="'+api_variant_title+'"] .variant_total_qty').html(invalue.available_qty);
                                              }
                                               if ((invalue.available_qty == 0 || invalue.available_qty == null)) {
                                                 meta_item_inventory +=  notify_me_stock;
                                                  current.find('.variant_inventories .qty_main_califonia .meta_product_inventory[data-variant_title="' + api_variant_title + '"]').attr('data-variant-id', invalue.variant_id);
                                                  current.find('.variant_inventories .qty_main_califonia .meta_product_inventory[data-variant_title="' + api_variant_title + '"]').attr('data-variant_price', invalue.price);
                                                  current.find('.variant_inventories .qty_main_califonia .meta_product_inventory[data-variant_title="' + api_variant_title + '"]').html(meta_item_inventory);
                                                  // current.find('.variant_inventories .qty_main_califonia .meta_product_inventory[data-variant_title="'+api_variant_title+'"] .variant_total_qty').html(invalue.available_qty);
                                                   const parentDiv = $('.notify_me_stock').closest('.variant_inventory');
                                                    if (parentDiv) {
                                                    parentDiv.addClass('hasNotifyme'); 
                                                    } 
                                                  
                                              }
                                          }
                                          if (invalue.location_id == 96170017071) {                                        
                                              current.find('.variant_inventories .qty_main_alabama .meta_product_inventory[data-variant_title="' + api_variant_title + '"]').removeClass('no-quantity');
                                              current.find('.variant_inventories .qty_main_alabama .meta_product_inventory[data-variant_title="' + api_variant_title + '"]').addClass(classNoQuantity);
                                              current.find('.variant_inventories .qty_main_alabama .meta_product_inventory[data-variant_title="' + api_variant_title + '"]').attr('data-variant_location_id', invalue.location_id);
                                              if (!(invalue.available_qty == 0 || invalue.available_qty == null)) {
                                                  meta_item_inventory +=  lowStock;
                                                  current.find('.variant_inventories .qty_main_alabama .meta_product_inventory[data-variant_title="' + api_variant_title + '"]').attr('data-variant-id', invalue.variant_id);
                                                  current.find('.variant_inventories .qty_main_alabama .meta_product_inventory[data-variant_title="' + api_variant_title + '"]').attr('data-variant_price', invalue.price);
                                                  current.find('.variant_inventories .qty_main_alabama .meta_product_inventory[data-variant_title="' + api_variant_title + '"]').html(meta_item_inventory);
                                              }

                                              if ((invalue.available_qty == 0 || invalue.available_qty == null)) {
                                                  meta_item_inventory +=  notify_me_stock;
                                                  current.find('.variant_inventories .qty_main_alabama .meta_product_inventory[data-variant_title="' + api_variant_title + '"]').attr('data-variant-id', invalue.variant_id);
                                                  current.find('.variant_inventories .qty_main_alabama .meta_product_inventory[data-variant_title="' + api_variant_title + '"]').attr('data-variant_price', invalue.price);
                                                  current.find('.variant_inventories .qty_main_alabama .meta_product_inventory[data-variant_title="' + api_variant_title + '"]').html(meta_item_inventory);
                                                   const parentDiv = $('.notify_me_stock').closest('.variant_inventory');
                                                    if (parentDiv) {
                                                    parentDiv.addClass('hasNotifyme'); 
                                                    } 
                                              }
                                          }
  
                                          // current.find('.variant_inventories').append(meta_item_inventory);
                                          current.find('.location_titles').css('display', 'block');
                                          current.find('.subtotal_inventory_variant').css('display', 'flex');
                                      }
                                  });
                              });
                          });

                          item_count++;
                      } else {
  
                      }
                  });            
                 
                  $.each(sortedSizesWithPrices, function(key, sizes) {
                      var variant_title = sizes.split(' :')[0];
                      var variant_price = sizes.split(': ')[1];
                      var variant_qty = sizes.split(': ')[2].trim();                   
                         
                      $(".meta_product_inventory").each(function() {
                          var variant_meta_title = $(this).attr('data-variant_title');
                          if(variant_meta_title == variant_title){
                              if(variant_qty != 'N/A'){
                                  $(this).find('.variant_qty_input').attr({
                                      "min": 1,
                                      "step": 1
                                  });
                                  $(this).find('.multiple_error').html('Please add quantity in multiple of '+ variant_qty);
                              }
                              else{
                                  $(this).find('.variant_qty_input').attr({
                                      "min": 1,
                                      "step": 1
                                  });
                              }
                          }
                      });
                  });              
              });
                 
                 if(item_count == dnr_item_count){
                         $("#notifyme").hide();
                }

			// Set null price to the albama price grid
              $('.related_pro_item .variant_loc_al .qty_main_alabama .variant_grid_price').each(function(index){
                     var variant_grid_price = $(this).html();
                 
                if(variant_grid_price == ""){
                  $(this).html("N/A");
                }
                 
                }) 
                
             $(document).on("blur", ".variant_qty_input", function() {
                  var inputValue = parseInt($(this).val());
                  var max_value = $(this).attr('max');
                  var variant_location_price = $(this).parent().attr('data-variant_price');
                  var variant_location_id = $(this).parent().attr('data-variant_location_id');
                  var variant_product_id = $(this).parents('.related_pro_item').attr('data-product_id');
  
                  var var_location_qty_sum = 0;
                  var var_location_price_sum = 0;
                  $(".related_pro_item").each(function(index) {
                      var related_id = $(this).attr('data-product_id');
                      var current = $(this);
                      var total_local_id = '';
  
                      if (variant_product_id == related_id) {
                          current.find('.meta_product_inventory').each(function(index) {
                              var meta_matchlocation_id = $(this).data('variant_location_id');
                              var current_location_qtys = $(this);
                              if (meta_matchlocation_id == variant_location_id) {
                                  total_local_id = variant_location_id;
                                  var var_location_qty = parseInt(current_location_qtys.find('.variant_qty_input').val());
                                  var var_location_price = parseFloat(current_location_qtys.attr('data-variant_price'));
                                  var sub_total_location = var_location_qty * var_location_price;
  
                                  if (isNaN(var_location_qty) != true) {
                                      // $('.inventory_submit').removeClass('cart-disable');
                                      var_location_qty_sum += var_location_qty;
                                      var_location_price_sum += sub_total_location;
                                  }
                              }
                          });
                      }
  
                      if (total_local_id == '96170017071') {
                          current.find('.location_alabma_subtotal .location_int_subtotal').text(var_location_qty_sum);
                          current.find('.location_alabma_subtotal .location_int_pricetotal').text('$' + new Intl.NumberFormat('us-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(var_location_price_sum));
                      }
                      if (total_local_id == '96169984303') {
                          current.find('.location_califonia_subtotal .location_int_subtotal').text(var_location_qty_sum);
                          current.find('.location_califonia_subtotal .location_int_pricetotal').text('$' + new Intl.NumberFormat('us-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(var_location_price_sum));
                      }
                  });
  
                  var atLeastOneHasValue = false;
  
                  $(".variant_qty_input").each(function() {
                      if ($(this).val().trim() !== "") {
                          atLeastOneHasValue = true;
                          return false; // Break the loop if any input has a value
                      }
                  });
  
                  if (atLeastOneHasValue) {
                      $('.inventory_submit').removeClass('cart-disable');
                      // Do something when at least one input has a value
                  } else {
                      $('.inventory_submit').addClass('cart-disable');
                      // Do something when no input has a value
                  }
              });

                $(".variant_qty_input").keypress(function(){
                    $('.inventory_submit').removeClass('cart-disable');
                });
  
              FilterHighStockItems();
          
              // future stock function
              $(".product_future_stock").each(function() {
                                
                  // Check if the div has inner HTML
                  if ($(this).html().trim() !== "") {
                      // Perform actions or log information about the div with inner HTML                
                      var product_check_handle = $(this).attr('data-handle');
                      var future_dates_unique_cal = [];
                      var future_dates_unique_al = [];
                      var datesArrAL = [];
                      var datesArrCA = [];
  
                      //california function to fetch dates and push to an array
                      $(this).find(".variant_california").each(function() {                        
                          var variant_title_check = $(this).attr('data-variant');                    
                          var future_stock_left = $(this).find('.stock_qty').html();
                          var future_stock_date = $(this).find('.stock_date').html();
                          var ids = $(this).attr('data-variant-stock-id');
                          var  california_stock_json = JSON.parse($(this).attr('data-variant_california_future_stock'));
                      
                          $(".related_pro_item").each(function() {
                              var related_check_handle = $(this).attr('data-product_handle');
                              var current = $(this);
                              if (product_check_handle == related_check_handle) {
                                  $.each(california_stock_json, function(i, item) {
                                      future_dates_unique_cal[i] = item.date;
                                  });
                                  
                                  if(california_stock_json.length > 0){
                                      current.find('.location_title[data-location_title=california]').prepend('<button type="button" class="show_future_stock_california '+related_check_handle+'">+</button>');
                                      current.find('.location_title[data-location_title=california]').find('.future_stock_dates').html('<span class="stock_title_invt">In Stock</span>');
                                  }
                              }
                          });
                          
                          $.merge(datesArrCA,future_dates_unique_cal);
                          // Use Set to remove duplicates dates
                          datesArrCA = [...new Set(datesArrCA)];
                          $.unique(datesArrCA);
                      });
  
                      datesArrCA = sortDates(datesArrCA);                    
                  
                      //california function to loop through date array and add it to the grid
                      $(".related_pro_item").each(function() {
                          var related_check_handle = $(this).attr('data-product_handle');
                          var current = $(this);
                          var currDate = new Date();
                          currDate.setHours(0, 0, 0, 0);
                         
                          if (product_check_handle == related_check_handle) {   
                             var cnt_future_rows = 0;
                              $.each(datesArrCA, function(key, dates) { 
                                 var futureDate = new Date(dates);
                                if(futureDate > currDate){
                                  current.find('.location_title[data-location_title=california]').find('.future_stock_dates').append('<span class="stock_date added_dates">' + dates + '</span>');
                                  cnt_future_rows++;
                                }
                              });    
                            if(cnt_future_rows == 0){
                              $("."+related_check_handle).hide();
                            }
                              current.find(".qty_main_califonia  .meta_product_inventory").each(function() {
                                  var variant_title = $(this).attr('data-variant_title');
                                  var location_id = $(this).attr('data-variant_location_id');                                
                                  var current_input = $(this);
                                  $.each(datesArrCA, function(key, dates) {                                
                                      current_input.append('<span class="future_stock new_date" data-date="' + dates + '" style="display:none">-</span>');
                                  });
                              });
                          }
                      });
  
                      //california function to loop through json object and add quantity to the dates div
                      $(this).find(".variant_california").each(function() {                    
                          var variant_title_check = $(this).attr('data-variant');                    
                          var california_stock_json = JSON.parse($(this).attr('data-variant_california_future_stock'));
                          $(".related_pro_item").each(function() {
                              var related_check_handle = $(this).attr('data-product_handle');
                              var current = $(this);
                              var currDate = new Date();
                                   currDate.setHours(0, 0, 0, 0);
                              if (product_check_handle == related_check_handle) {
                                  current.find(".qty_main_califonia  .meta_product_inventory").each(function() {
                                      var variant_title = $(this).attr('data-variant_title');
                                      if (variant_title_check == variant_title) {                                    
                                          var current_input = $(this);
                                          $.each(california_stock_json, function(key, dates) {
                                              var future_stock_qty = dates.quantity;
                                              if(future_stock_qty == 0){
                                                  future_stock_qty = '-';
                                              } 
                                              var futureDate = new Date(dates.date);
                                if(futureDate > currDate){
                                              current_input.find('.future_stock[data-date="' + dates.date + '"]').empty();
                                              current_input.find('.future_stock[data-date="' + dates.date + '"]').addClass('stock_added');
                                              current_input.find('.future_stock[data-date="' + dates.date + '"]').append(future_stock_qty);
                                }
                                          });
                                      }
                                  });
                              }
                          });
                      });
  
                      //alabama function to fetch dates and push to an array
                      $(this).find(".variant_alabama").each(function() {
                          var variant_title_check = $(this).attr('data-variant');
                          var alabama_stock_json = JSON.parse($(this).attr('data-variant_alabama_future_stock'));
                          $(".related_pro_item").each(function() {
                              var related_check_handle = $(this).attr('data-product_handle');
                              var current = $(this);
                              if (product_check_handle == related_check_handle) {
                                  $.each(alabama_stock_json, function(i, item) {
                                      future_dates_unique_al[i] = item.date;
                                  });
                                  if(alabama_stock_json.length > 0){ 
                                    console.log(alabama_stock_json);
                                      current.find('.location_title[data-location_title=alabama]').prepend('<button type="button" class="show_future_stock_alabama '+related_check_handle+'">+</button>');
                                      current.find('.location_title[data-location_title=alabama]').find('.future_stock_dates').html('<span class="stock_title_invt">In Stock</span>');
                                  }
                              }
                          });
                          $.merge(datesArrAL,future_dates_unique_al);
                          // Use Set to remove duplicates dates
                          datesArrAL = [...new Set(datesArrAL)];
                          $.unique(datesArrAL);
                      });
                     
                      datesArrAL = sortDates(datesArrAL);             
                      
                      //alabama function to loop through date array and add it to the grid
                      $(".related_pro_item").each(function() {
                          var related_check_handle = $(this).attr('data-product_handle');
                          var current = $(this);
                           var currDate = new Date();
                               currDate.setHours(0, 0, 0, 0);
                          if (product_check_handle == related_check_handle) {
                              var cnt_future_rows = 0;
                              $.each(datesArrAL, function(key, dates) {
                                  var futureDate = new Date(dates);
                                if(futureDate > currDate){
                                  current.find('.location_title[data-location_title=alabama]').find('.future_stock_dates').append('<span class="stock_date">' + dates + '</span>');
                                  cnt_future_rows++;
                                }
                              });
                            if(cnt_future_rows == 0){
                              $("."+related_check_handle).hide();
                            }
                              current.find(".qty_main_alabama   .meta_product_inventory").each(function() {
                                  var variant_title = $(this).attr('data-variant_title');
                                  var location_id = $(this).attr('data-variant_location_id');
                                  var current_input = $(this);
                                  $.each(datesArrAL, function(key, dates) {
                                    var futureDate = new Date(dates);
                                if(futureDate > currDate){
                                      current_input.append('<span class="future_stock" data-date="' + dates + '" style="display:none">-</span>');
                                }
                                  });
                              });
                          }
                      });
  
                      //alabama function to loop through json object and add quantity to the dates div
                      $(this).find(".variant_alabama").each(function() {
                          var variant_title_check = $(this).attr('data-variant');;
                          var alabama_stock_json = JSON.parse($(this).attr('data-variant_alabama_future_stock'));
                              var currDate = new Date();
                                   currDate.setHours(0, 0, 0, 0);
                          $(".related_pro_item").each(function() {
                              var related_check_handle = $(this).attr('data-product_handle');
                              var current = $(this);
                              if (product_check_handle == related_check_handle) {
                                  current.find(".qty_main_alabama   .meta_product_inventory").each(function() {
                                      var variant_title = $(this).attr('data-variant_title');
                                      if (variant_title_check == variant_title) {                                    
                                          var current_input = $(this);                                               
                                          $.each(alabama_stock_json, function(key, dates) {
                                              var future_stock_qty = dates.quantity;
                                              if(future_stock_qty == 0){
                                                  future_stock_qty = '-';
                                              }
                                             var futureDate = new Date(dates.date);
                                if(futureDate > currDate){
                                              current_input.find('.future_stock[data-date="' + dates.date + '"]').empty();
                                              current_input.find('.future_stock[data-date="' + dates.date + '"]').addClass('stock_added');
                                              current_input.find('.future_stock[data-date="' + dates.date + '"]').append(future_stock_qty); 
                                }
                                          });
                                      }
                                  });
                              }
                          });
                      });            
                  }
              });
  
              var stored_cart_string = localStorage.getItem('selected_variant_detail')
              var stored_cart_array = stored_cart_string ? JSON.parse(stored_cart_string) : [];
  
              if (stored_cart_array.length > 0) {
                  var input_max_check = [];
                  $(".variant_qty_input").each(function() {
                      var variant_id = parseInt($(this).parent().attr('data-variant-id'));
                      var location_id = parseInt($(this).parent().attr('data-variant_location_id'));
                      var avalaible_qty = parseInt($(this).attr('max').replace(/'/g, ''));
                      var variant_qty_obj = {
                          'local_loc_id': location_id,
                          'local_var_id': variant_id,
                          'local_var_available': avalaible_qty
                      };
                      input_max_check.push(variant_qty_obj);
                  });
  
                  // Remove single quotes from values in input_max_check
                  input_max_check = input_max_check.map(item => {
                      return {
                          local_loc_id: item.local_loc_id,
                          local_var_id: item.local_var_id,
                          local_var_available: item.local_var_available
                      };
                  });
  
                  stored_cart_array.forEach((firstItem) => {
                      const matchingItem = input_max_check.find((secondItem) => secondItem.local_loc_id === firstItem.local_loc_id && secondItem.local_var_id === firstItem.local_var_id);
                      if (matchingItem) {
                          matchingItem.local_var_available = parseInt(firstItem.local_var_qty);
                      }
                  });
  
                  // Filter objects in second_array based on matching local_loc_id and local_var_id
                  var filteredArray = input_max_check.filter(secondItem => {
                      return stored_cart_array.some(firstItem => {
                          return (
                              secondItem.local_loc_id === firstItem.local_loc_id &&
                              secondItem.local_var_id === firstItem.local_var_id
                          );
                      });
                  });
  
                  $('.variant_qty_input').each(function() {
                      var input = $(this);
                      var parentDiv = input.parent();
                      var variantLocationId = parentDiv.data('variant_location_id');
                      var variantId = parentDiv.data('variant-id');
                      var max_qty = parseInt($(this).attr('max'));
                      // Check if the variantLocationId matches any local_loc_id in the secondArray
                      if (filteredArray.some(item => item.local_loc_id === variantLocationId && item.local_var_id === variantId && item.local_var_available === max_qty)) {
                          parentDiv.addClass('qty_added_disable'); 
                      }
                  });
              }
  
              $(".variant_qty_input").each(function() {
                  var input = $(this);
                  var avalaible_qty = parseInt($(this).attr('max').replace(/'/g, ''));
                  if(avalaible_qty <= 0 ){
                      input.addClass('qty_added_disable');
                  }
              });
          },
          error: function() {
              alert('Some error found. Please try again!');
          }
      });
    }
  
    $(".inventory_submit").on('click', function(e) {
        var variant_local_arr_main = [];
        var items = [];
        $('.variant_qty_input').each(function(index) {
            var selected_variantqty = $(this).val();
            var current_qty = $(this);

            if (selected_variantqty != '') {
                var loc_pack_qty = current_qty.parent().data('pack-qty');
                var loc_product_id = current_qty.parents('.related_pro_item').data('product_id');
                var loc_product_handle = current_qty.parents('.related_pro_item').data('product_handle');
                var loc_pro_img_url = current_qty.parents('.related_pro_item').find('img').attr('src');
                var loc_pro_title = current_qty.parents('.variant_inventories').data('product_title');
                var local_var_id = current_qty.parent().data('variant-id');
                var local_loc_id = current_qty.parent().data('variant_location_id');
                var local_var_available = current_qty.parent().find('.variant_total_qty').text();
                var local_var_title = current_qty.parent().data('variant_title');
                var local_var_price = current_qty.parent().data('variant_price');
                var product_title = current_qty.parents('.related_pro_item').data('main_product_title');
                var product_sku = current_qty.parents('.related_pro_item').data('product_sku');

                var variant_local_arr = {
                    'loc_pack_qty': loc_pack_qty,
                    'loc_product_id': loc_product_id,
                    'loc_product_handle': loc_product_handle,
                    'loc_pro_img_url': loc_pro_img_url,
                    'var_loc_pro_title': loc_pro_title,
                    'local_loc_id': local_loc_id,
                    'local_var_id': local_var_id,
                    'local_var_available': local_var_available,
                    'local_var_title': local_var_title,
                    'local_var_price': local_var_price,
                    'local_var_qty': selected_variantqty,
                    'product_title': product_title,
                    'product_sku': product_sku
                };

                if (selected_variantqty > 0) {
                    items.push({
                        id: local_var_id,
                        quantity: selected_variantqty
                    });
                }
                variant_local_arr_main.push(variant_local_arr);
            }
        });

        $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: {
                items: items
            },
            dataType: 'json',
            success: function() {
                window.location.href = '/pages/cart';

                var location_item_string = localStorage.getItem('selected_variant_detail')
                var location_item_array = location_item_string ? JSON.parse(location_item_string) : [];
                var empty_cart = jQuery.isEmptyObject(location_item_array);
                if (empty_cart == true) {
                    localStorage.setItem("selected_variant_detail", JSON.stringify(variant_local_arr_main));
                    var location_item_string1 = localStorage.getItem('selected_variant_detail')
                    var location_item_array1 = location_item_string1 ? JSON.parse(location_item_string1) : [];
                } else {
                    function updateOrCreateArray(firstArray, secondArray) {
                        const combinedArray = [];
                        // Combine matching items and non-matching items from the first array
                        firstArray.forEach((firstItem) => {
                            const matchingSecondItem = secondArray.find(
                                (secondItem) =>
                                secondItem.loc_product_id === firstItem.loc_product_id &&
                                secondItem.local_var_id === firstItem.local_var_id &&
                                secondItem.local_loc_id === firstItem.local_loc_id
                            );
                            if (matchingSecondItem) {
                                // If a matching item is found, update the quantity
                                const updatedQuantity = parseInt(firstItem.local_var_qty) + parseInt(matchingSecondItem.local_var_qty);
                                combinedArray.push({
                                    ...firstItem,
                                    local_var_qty: updatedQuantity.toString(),
                                });

                                // Remove the matched item from the second array to avoid duplicates
                                const index = secondArray.indexOf(matchingSecondItem);
                                if (index !== -1) {
                                    secondArray.splice(index, 1);
                                }
                            } else {
                                // If no matching item is found, add the original item
                                combinedArray.push(firstItem);
                            }
                        });

                        // Add remaining items from the second array
                        combinedArray.push(...secondArray);
                        return combinedArray;
                    }
                    const resultArray = updateOrCreateArray(variant_local_arr_main, location_item_array);
                    localStorage.setItem("selected_variant_detail", JSON.stringify(resultArray));
                }
                updateCartCount();
            },
            error: function(error) {
                alert(error.responseJSON.description);
            }
        });
    });

    $('#locationFilterDropdown').on('change', function() {
        var active_location = $(this).val();
        var current_filter_location = $(this);

        $('.qty_location_main').hide();
        $('.location_title').hide();
        $('.location_inventory_variant_inner').hide();

        if ($(".high_stock").prop('checked') == true) {     
              
            if (active_location == 'Alabama') {               
                $('.variant_loc_cal').hide();
                $('.variant_loc_al').show();
                $('.product_inventory_data').addClass('center-location-item');
            } else if (active_location == 'California') {
                $('.variant_loc_al').hide();
                $('.variant_loc_cal').show();
                $('.product_inventory_data').addClass('center-location-item');
            } else {
                $('.variant_inventories .variant_inventory').show();
                $('.product_inventory_data').removeClass('center-location-item');
                // checksingle_location_center();
            }
        } else {
            $('.qty_location_main').show();
            $('.location_title, .location_inventory_variant_inner').show();
            if (active_location == 'Alabama') {               
                $('.variant_loc_cal').hide();
                $('.variant_loc_al').show();
                $('.product_inventory_data').addClass('center-location-item');
            } else if (active_location == 'California') {
                $('.variant_loc_al').hide();
                $('.variant_loc_cal').show();
                $('.product_inventory_data').addClass('center-location-item');
            } else {
                $('.variant_inventories .variant_inventory').show();
                $('.product_inventory_data').removeClass('center-location-item');
                // checksingle_location_center();
            }        
        }
    });
    
    // Select All button click event
    $("#selectAll").click(function() {
        $(".high_stock").prop('checked', false);
        $(".related_pro_item").show();
        if ($('#colorDropdown_options input:checked').length == $('#colorDropdown_options input').length) {
            //do something
            $("#colorDropdown_options input[type='checkbox']").prop("checked", false);
            $("#selectAll input[type='checkbox']").prop("checked", false);
        } else {
            $("#colorDropdown_options input[type='checkbox']").prop("checked", true);
            $('.selected_colors').html('All Colors');
            $("#selectAll input[type='checkbox']").prop("checked", true);
        }
    });

    // Clear All button click event 
    $("#clearAll").click(function() {
        $(".high_stock").prop('checked', false);
        $(".related_pro_item").show();
        $("#colorDropdown input[type='checkbox']").prop("checked", false);
        $('.selected_colors').html('All Colors');
    });
    $("#allColors label").click(function() {
        $("#colorDropdown").toggle();
    });

    $("#colorDropdown input").click(function() {
        $(".high_stock").prop('checked', false);        
        $(".variant_inventory,.location_title, .qty_location_main").show();        
        var active_location = $('#locationFilterDropdown').val();
        if (active_location == 'Alabama') {        
            $('.variant_loc_cal').hide();
            $('.variant_loc_al').show();
        }
        else if (active_location == 'California') {
            $('.variant_loc_al').hide();
            $('.variant_loc_cal').show();
        }
        else{
            $('.variant_inventories .variant_inventory').show();
        }
        
        if($('#colorDropdown_options input:checked').length == 0){
            $('.selected_colors').html('All Colors');
        }
        else{
            $('.selected_colors').html($('#colorDropdown_options input:checked').length + ' colors selected');
        }
    
        if ($('#colorDropdown_options input:checked').length == $('#colorDropdown_options input').length) {
            $("#selectAll input[type='checkbox']").prop("checked", true);
        } else {
            $("#selectAll input[type='checkbox']").prop("checked", false);
        }

        if ($('#colorDropdown_options input:checked').length < 1) {
            $(".related_pro_item").show();
            $('.related_pro_item:first-child').removeClass('single_related');
        } else {
            $(".related_pro_item").hide();
            if ($('#colorDropdown_options input:checked:checked').length == 1) {
                $('.related_pro_item:first-child').addClass('single_related');
            } else {
                $('.related_pro_item:first-child').removeClass('single_related');
            }
            $("ul#colorDropdown input:checkbox:checked").each(function() {
                var product_handle_color = $(this).parents('li').attr('data-product_handle');
                $(".related_pro_item").each(function(index) {
                    var product_handle_rel_item = $(this).attr('data-product_handle');
                    var current_related = $(this);
                    if (product_handle_color == product_handle_rel_item) {
                        current_related.css('display', 'flex');
                    }
                });
            });
        }
    });

    var pack_qty_input = parseInt($('.pack_size_qty').data('pack_qty'));

    // check multiple of case qty
    function isMultipleOfQty(value) {
        return value % pack_qty_input === 0;
    }    

    $(document).on("click", ".variant_qty_input", function() {
        $('.error_input_iventory').hide();
    });

    // Qty validations
     $(document).on("change", ".variant_qty_input", function() {            
        var inputValue = parseInt($(this).val().trim());
        var max_available = parseInt($(this).attr('max'));
        var result = isMultipleOfQty(inputValue);
        var pack_qty_product = parseInt($(this).attr('step'));
        var pack_qty_na_product = $(this).attr('step');
        var current = $(this);
           
        if(pack_qty_na_product != 'N/A') {
            if (inputValue){                  
                if(max_available < inputValue){                           
                    current.val('');
                    current.addClass('qty_error');                    
                    current.next().show();
                    current.next().find('.max_error').show();
                    current.next().find('.multiple_error').hide();
                    current.next().delay(4000).fadeOut(200);
                    setTimeout(function() {
                        current.removeClass('qty_error');
                        current.focus();
                    }, 4000);                             
                }else{                          
                    if(!(inputValue % pack_qty_product === 0)){
                        current.val('');
                        current.next().show();
                        $('.ui-tooltip').fadeIn();
                        current.next().find('.multiple_error').show();
                        current.next().find('.max_error').hide();
                        setTimeout(function() {
                            current.removeClass('qty_error');
                            current.focus();
                            current.next().hide();
                        }, 4000);                              
                    } else {                                
                        current.next().hide();
                        current.removeClass("error");
                    }
                }
      
                if(max_available > inputValue){
                    if (!result) {
                        if(pack_qty_input){
                            current.val('');
                            current.addClass('qty_error');
                            current.next().delay(4000).fadeOut(200);
                            setTimeout(function() {
                                current.removeClass('qty_error');
                                current.focus();
                            }, 4000);
                        }
                    } 
                }
            } else {                     
                current.next().hide();
                current.removeClass("error");
            }
        } else{
            if(max_available < inputValue){                            
                current.val('');
                current.addClass('qty_error');                
                current.next().show();
                current.next().find('.max_error').show();
                current.next().find('.multiple_error').hide();
                current.next().delay(4000).fadeOut(200);
                setTimeout(function() {
                    current.removeClass('qty_error');
                    current.focus();
                }, 4000);
                
            }
        }
    }); 
    
    // High stock functions 
    function checkhighstock() {

        if ($(".high_stock").prop('checked') == true) {

            $(".related_pro_item").show();
            $('.qty_location_main').show();
            $('.location_title, .location_inventory_variant_inner').show();
            $('.location_title').removeClass('show_loc');
            $('.location_inventory_variant_inner').removeClass('highstockloc_price_active');
            $('.qty_location_main').removeClass('highstocklocation_active');
            $('.location_inventory_variant_inner').removeClass('highstockloc_price_filter');    
        } else {     
            var count_stock = 0;
            $(".related_pro_item").each(function(index) {
                var current_item = $(this);
                var current = $(this).attr('class');
                if (current.includes('high_stock_item')) {
                    $(".related_pro_item").hide();
                    $(".high_stock_item").show();
                    $('.qty_location_main').hide();
                    $('.location_title, .location_inventory_variant_inner').hide();
                    current_item.find('.qty_location_main').each(function(index) {
                        var current_location = $(this);
                        var current_location_class = $(this).attr('class');
                        if (current_location_class.includes('highstocklocation')) {
                            current_location.show();
                            current_location.addClass('highstocklocation_active')
                        }
                    });

                    current_item.find('.location_title').each(function(index) {
                        var current_location = $(this);                    
                        var current_location_class = $(this).attr('class');
                        if (current_location_class.includes('highstocklocationtitle')) {
                            current_location.show();
                            current_location.addClass('show_loc');                        
                        }
                    });
                    var count_high_stock = 0;
                    current_item.find('.location_inventory_variant_inner').each(function(index) {
                        var current_location = $(this);
                        var current_location_class = $(this).attr('class');
                        if (current_location_class.includes('highstockloc_price')) {
                            current_location.show();
                            count_high_stock ++ ;
                        
                            if(count_high_stock == 1){
                                current_location.addClass('highstockloc_price_filter');
                            }
                            if(count_high_stock == 2){
                                current_item.find('.location_inventory_variant_inner').removeClass('highstockloc_price_filter');
                            }
                            current_location.addClass('highstockloc_price_active');
                        }
                    });
                }
            });          
        }

         setTimeout(function () {
                     $(".spinner-overlay").hide();
                 }, 2000);
        
        
    }
    
    function checksingle_location_center(){
        $(".related_pro_item").each(function(index) {
            var center_count = 0;
            var current_product = $(this);

            $(this).find('.location_title').each(function() {
                var current = $(this).attr('class');
                var displayPropertyValue = $(this).css('display');
            
                if (current.includes('show_loc')) {
                    center_count ++;                
                    if(center_count == 1){
                        current_product.find('.product_inventory_data').addClass('center-location-item');
                    }
                    if(center_count == 2){
                        current_product.find('.product_inventory_data').removeClass('center-location-item');
                    }
                }
            });
        });        
    }
   
    $('#highstockinventory').on('click', function() {
  $(".spinner-overlay").show();
   
        $("#colorDropdown input[type='checkbox']").prop("checked", false);
        $('.selected_colors').html('All Colors');
        $(".related_pro_item").show();

        checkhighstock();

        var active_location = $('#locationFilterDropdown').val();
            
        if (active_location == 'Alabama') {            
            $('.product_inventory_data').addClass('center-location-item');
        }
        else if (active_location == 'California') {
            $('.product_inventory_data').addClass('center-location-item');
        }
        else{
            $('.product_inventory_data').removeClass('center-location-item');
        }            
    });

    $('#highstockinventory').on('click', function() {
        $(".high_stock").prop("checked", !$(".high_stock").prop("checked"));
    });
    
    var selected_cart_items = window.localStorage.getItem("selected_variant_detail");
    var array_selected_products = selected_cart_items ? JSON.parse(selected_cart_items) : [];

    // Filter the array based on the location ID
    var checkout_progress_alabama = localStorage.getItem('checkout_alabama_in_progress');
    var checkout_progress_california = localStorage.getItem('checkout_california_in_progress');
   
    $.ajax({
        type: 'GET',
        url: '/cart.js',
        cache: false,
        dataType: 'json',
        success: function(cart) {
            if(cart.item_count == 0){           
                var location_item_string = localStorage.getItem('selected_variant_detail')
                var location_item_array = location_item_string ? JSON.parse(location_item_string) : [];          
                if(checkout_progress_california == 'true'){
                    localStorage.removeItem("checkout_california_in_progress");
                    localStorage.removeItem("checkout_alabama_in_progress");            
                    const filteredArray = location_item_array.filter(item => item.local_loc_id !== 96169984303);                
                    localStorage.setItem('selected_variant_detail', JSON.stringify(filteredArray));
                }

                if(checkout_progress_alabama == 'true'){
                    localStorage.removeItem("checkout_california_in_progress");
                    localStorage.removeItem("checkout_alabama_in_progress");                
                    const filteredArray = location_item_array.filter(item => item.local_loc_id !== 96170017071);                
                    localStorage.setItem('selected_variant_detail', JSON.stringify(filteredArray));
                }

                var appendProducts = [];
                var i;
                var j = 0;

                array_selected_products.forEach(function(cartItems) {                
                    // return item.local_loc_id === targetLocationID_California;
                    var image_url =  cartItems.loc_pro_img_url;
                    if (image_url.indexOf("no-image") != -1) { 
                        image_url =  "//www.nextlevelapparel.com/cdn/shop/files/coming_soon.png?v=1787160642";
                    }else{
                        image_url =  cartItems.loc_pro_img_url;
                    }
                    if(cartItems.loc_pack_qty == 'N/A'){
                        var multiple_error = 'Please add quantity more than 1';
                    }else{
                        var multiple_error = 'Please add quantity in multiple of  '+ cartItems.loc_pack_qty;
                    }
                    var sub_total_price = (cartItems.local_var_price * cartItems.local_var_qty);
                    var sub_total = new Intl.NumberFormat('us-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(sub_total_price);
                    var CartItemsAvailable = '';
                    if(cartItems.local_var_available > 10000){
                        CartItemsAvailable = '10000+';
                    }else{
                        CartItemsAvailable = cartItems.local_var_available;
                    }
                    var cartHTML1 = '<li data-pack_qty=' + cartItems.loc_pack_qty + ' data-product_id=' + cartItems.loc_product_id + ' data-variant_id=' + cartItems.local_var_id + ' data-location_id=' + cartItems.local_loc_id + '>'; 
                    cartHTML1 += '<div class="items_details" ><a href="/products/' + cartItems.loc_product_handle+'"><img alt="view ' + cartItems.product_title + ' in ' + cartItems.var_loc_pro_title + ' color" src=' + image_url + '></a><div class="product-item-details"><a href="/products/' + cartItems.loc_product_handle+'"><span class="product-sku">' + cartItems.product_sku + '</span>' + cartItems.product_title + '</a><span class="cart_product_color text-sm">Color: ' + cartItems.var_loc_pro_title + '</span></div></div>';
                    cartHTML1 += '<div class="items_price ' + cartItems.loc_product_id + '"><span class="mobile_cartHeadings"><b>Price: </b> </span><div class="variant_price"><span class="unit_price"> $' + cartItems.local_var_price + '</span></div></div>';
                    cartHTML1 += '<div class="items_qty ' + cartItems.loc_product_id + '"><span class="mobile_cartHeadings"><b>Qty: </b></span><div class="variant_quantity"><label class="variant_title">' + cartItems.local_var_title + '</label><div class="qty_selector"><button type="button" id="sub" class="sub">-</button><input type="number" class="quantity-input_cart" data-varaintId=' + cartItems.local_var_id + ' data-varaintPrice=' + cartItems.local_var_price + ' value="' + cartItems.local_var_qty + '" min="1" max="' + cartItems.local_var_available + '" /> <button type="button" id="add" class="add">+</button><span class="error_input_iventory text-xs" style="display: none;"><label class="multiple_error">'+ multiple_error +'</label><label class="max_error" style="display: none;">Please add quantity less than or equal to ' + cartItems.local_var_available + '</label></span></div><button class="remove_item" aria-label="Remove item">X</button></div></div><div class="items_available ' + cartItems.loc_product_id + '"><span class="mobile_cartHeadings"><b>Available: </b></span><div class="variant_available">' + CartItemsAvailable + '</div></div>';
                    cartHTML1 += '<div class="items_subtotal"><span class="mobile_cartHeadings"><b>Subtotal: </b></span><span class="sub-total_price ' + cartItems.loc_product_id + '">$' + sub_total + '</div></div>';
                    cartHTML1 += '</li>';              

                    if(j == 0){
                        if (cartItems.local_loc_id == 96169984303) {
                            //  Display the cart HTML on your page
                            $('#cart_california #cartItems').append(cartHTML1);
                            $('#cart_california').css('display', 'flex');                    
                        }
                        if (cartItems.local_loc_id == 96170017071) {
                            //  Display the cart HTML on your page
                            $('#cart_alabama #cartItems').append(cartHTML1);
                            $('#cart_alabama').css('display', 'flex');                    
                        }
                        j++;
                    }else{
                        var flag = 0;
                        for(i = 0; i < appendProducts.length; i++) { 
                            if(appendProducts[i].product_id == cartItems.loc_product_id && appendProducts[i].location_id == cartItems.local_loc_id && flag == 0){
                                var variantPrice = '<div class="variant_price"><span class="unit_price"> $' + cartItems.local_var_price + '</span></div>';
                                var variantQuantity = '<div class="variant_quantity"><label class="variant_title">' + cartItems.local_var_title + '</label><div class="qty_selector"><button type="button" id="sub" class="sub">-</button><input type="number"  class="quantity-input_cart" data-varaintId=' + cartItems.local_var_id + ' data-varaintPrice=' + cartItems.local_var_price + ' value="' + cartItems.local_var_qty + '" min="1" max="' + cartItems.local_var_available + '" /> <button type="button" id="add" class="add">+</button><span class="error_input_iventory text-xs" style="display: none;"><label class="multiple_error">'+ multiple_error +'</label><label class="max_error" style="display: none;">Please add quantity less than or equal to ' + cartItems.local_var_available + '</label></span></div><button class="remove_item" aria-label="Remove item">X</button></div>';
                                var variantAvailable = '<div class="variant_available">' + CartItemsAvailable + '</div>';

                                if (cartItems.local_loc_id == 96169984303) {
                                    //  Display the cart HTML on your page
                                    var priceClass = '#cart_california #cartItems .items_price.' + cartItems.loc_product_id;
                                    var quantityClass = '#cart_california #cartItems .items_qty.' + cartItems.loc_product_id;
                                    var availableClass = '#cart_california #cartItems .items_available.' + cartItems.loc_product_id;
                                    var totalPriceClass = '#cart_california #cartItems .sub-total_price.' + cartItems.loc_product_id;
                                    $(priceClass).append(variantPrice);
                                    $(quantityClass).append(variantQuantity);
                                    $(availableClass).append(variantAvailable);
                                    var variantPrevPrice = $(totalPriceClass).text().replace('$', '').replace(',', '');
                                    var unitVariantPrice =  cartItems.local_var_price * cartItems.local_var_qty;
                                    var variantTotal = (parseFloat(variantPrevPrice) + parseFloat(unitVariantPrice)).toFixed(2);
                                    var variantTotalPrice = new Intl.NumberFormat('us-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(variantTotal);
                                    $(totalPriceClass).html('$' + variantTotalPrice);
                                }
                                if (cartItems.local_loc_id == 96170017071) {
                                    //  Display the cart HTML on your page
                                    var priceClass = '#cart_alabama #cartItems .items_price.' + cartItems.loc_product_id;
                                    var quantityClass = '#cart_alabama #cartItems .items_qty.' + cartItems.loc_product_id;
                                    var availableClass = '#cart_alabama #cartItems .items_available.' + cartItems.loc_product_id;
                                    var totalPriceClass = '#cart_alabama #cartItems .sub-total_price.' + cartItems.loc_product_id;
                                    $(priceClass).append(variantPrice);
                                    $(quantityClass).append(variantQuantity);
                                    $(availableClass).append(variantAvailable);

                                    var variantPrevPrice = $(totalPriceClass).text().replace('$', '').replace(',', '');
                                    var unitVariantPrice =  cartItems.local_var_price * cartItems.local_var_qty;
                                    var variantTotal = (parseFloat(variantPrevPrice) + parseFloat(unitVariantPrice)).toFixed(2);
                                    var variantTotalPrice = new Intl.NumberFormat('us-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(variantTotal);
                                    $(totalPriceClass).html('$' + variantTotalPrice);
                                }
                                flag = 1;
                            }
                        }
                    }
                    if(flag == 0){
                        if (cartItems.local_loc_id == 96169984303) {
                            //  Display the cart HTML on your page
                            $('#cart_california #cartItems').append(cartHTML1);
                            $('#cart_california').css('display', 'flex');                    
                        }
                        if (cartItems.local_loc_id == 96170017071) {
                            //  Display the cart HTML on your page
                            $('#cart_alabama #cartItems').append(cartHTML1);
                            $('#cart_alabama').css('display', 'flex');                    
                        }
                    }
                    var productAdded = {
                        'product_id': cartItems.loc_product_id,
                        'location_id': cartItems.local_loc_id
                    }
                    appendProducts.push(productAdded);
                });
                updateCartTotal();
                updateCartCount();
            }
            if(cart.item_count > 0){
                $('.empty_loc_cart').hide();
                // Filter the array based on the location ID
                var appendProducts = [];
                var i;
                var j = 0;
                array_selected_products.forEach(function(cartItems) {
                    var image_url =  cartItems.loc_pro_img_url;
                    if (image_url.indexOf("no-image") != -1) { 
                        image_url =  "//www.nextlevelapparel.com/cdn/shop/files/coming_soon.png?v=1787160642";
                    }else{
                        image_url =  cartItems.loc_pro_img_url;
                    } 
                    if(cartItems.loc_pack_qty == 'N/A'){
                        var multiple_error = 'Please add quantity more than 1';
                    }else{
                        var multiple_error = 'Please add quantity in multiple of  '+ cartItems.loc_pack_qty;
                    }
                    var sub_total_price = (cartItems.local_var_price * cartItems.local_var_qty);
                    var sub_total = new Intl.NumberFormat('us-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(sub_total_price);
                    var CartItemsAvailable = '';
                    if(cartItems.local_var_available > 10000){
                        CartItemsAvailable = '10000+';
                    }else{
                        CartItemsAvailable = cartItems.local_var_available;
                    }
                        
                    var cartHTML1 = '<li data-pack_qty=' + cartItems.loc_pack_qty + ' data-product_id=' + cartItems.loc_product_id + ' data-variant_id=' + cartItems.local_var_id + ' data-location_id=' + cartItems.local_loc_id + '>'; 
                    cartHTML1 += '<div class="items_details" ><a href="/products/' + cartItems.loc_product_handle+'"><img alt="view ' + cartItems.product_title + ' in ' + cartItems.var_loc_pro_title + ' color"  src=' + image_url + '></a><div class="product-item-details"><a href="/products/' + cartItems.loc_product_handle+'"><span class="product-sku">' + cartItems.product_sku + '</span>' + cartItems.product_title + '</a><span class="cart_product_color text-sm">Color: ' + cartItems.var_loc_pro_title + '</span></div></div>';
                    cartHTML1 += '<div class="items_price ' + cartItems.loc_product_id + '"><span class="mobile_cartHeadings"><b>Price: </b> </span><div class="variant_price"><span class="unit_price"> $' + cartItems.local_var_price + '</span></div></div>';
                    cartHTML1 += '<div class="items_qty ' + cartItems.loc_product_id + '"><span class="mobile_cartHeadings"><b>Qty: </b></span><div class="variant_quantity"><label class="variant_title">' + cartItems.local_var_title + '</label><div class="qty_selector"><button type="button" id="sub" class="sub">-</button><input type="number" class="quantity-input_cart" data-varaintId=' + cartItems.local_var_id + ' data-varaintPrice=' + cartItems.local_var_price + ' value="' + cartItems.local_var_qty + '" min="1" max="' + cartItems.local_var_available + '" /> <button type="button" id="add" class="add">+</button><span class="error_input_iventory text-xs" style="display: none;"><label class="multiple_error">'+ multiple_error +'</label><label class="max_error" style="display: none;">Please add quantity less than or equal to ' + cartItems.local_var_available + '</label></span></div><button class="remove_item" aria-label="Remove item">X</button></div></div><div class="items_available ' + cartItems.loc_product_id + '"><span class="mobile_cartHeadings"><b>Available: </b></span><div class="variant_available">' + CartItemsAvailable + '</div></div>';
                    cartHTML1 += '<div class="items_subtotal"><span class="mobile_cartHeadings"><b>Subtotal: </b></span><span class="sub-total_price ' + cartItems.loc_product_id + '">$' + sub_total + '</div></div>';
                    cartHTML1 += '</li>';
                    
                    if(j == 0){
                        if (cartItems.local_loc_id == 96169984303) {
                            //  Display the cart HTML on your page
                            $('#cart_california #cartItems').append(cartHTML1);
                            $('#cart_california').css('display', 'flex');                    
                        }
                        if (cartItems.local_loc_id == 96170017071) {
                            //  Display the cart HTML on your page
                            $('#cart_alabama #cartItems').append(cartHTML1);
                            $('#cart_alabama').css('display', 'flex');                    
                        }
                        j++;
                    }else{
                        var flag = 0;
                        for(i = 0; i < appendProducts.length; i++) { 
                            if(appendProducts[i].product_id == cartItems.loc_product_id && appendProducts[i].location_id == cartItems.local_loc_id && flag == 0){
                                var variantPrice = '<div class="variant_price"><span class="unit_price"> $' + cartItems.local_var_price + '</span></div>';
                                var variantQuantity = '<div class="variant_quantity"><label class="variant_title">' + cartItems.local_var_title + '</label><div class="qty_selector"><button type="button" id="sub" class="sub">-</button><input type="number"  class="quantity-input_cart" data-varaintId=' + cartItems.local_var_id + ' data-varaintPrice=' + cartItems.local_var_price + ' value="' + cartItems.local_var_qty + '" min="1" max="' + cartItems.local_var_available + '" /> <button type="button" id="add" class="add">+</button><span class="error_input_iventory text-xs" style="display: none;"><label class="multiple_error">'+ multiple_error +'</label><label class="max_error" style="display: none;">Please add quantity less than or equal to ' + cartItems.local_var_available + '</label></span></div><button class="remove_item" aria-label="Remove item">X</button></div>';
                                var variantAvailable = '<div class="variant_available">' + CartItemsAvailable + '</div>';

                                if (cartItems.local_loc_id == 96169984303) {
                                    //  Display the cart HTML on your page
                                    var priceClass = '#cart_california #cartItems .items_price.' + cartItems.loc_product_id;
                                    var quantityClass = '#cart_california #cartItems .items_qty.' + cartItems.loc_product_id;
                                    var availableClass = '#cart_california #cartItems .items_available.' + cartItems.loc_product_id;
                                    var totalPriceClass = '#cart_california #cartItems .sub-total_price.' + cartItems.loc_product_id;
                                    $(priceClass).append(variantPrice);
                                    $(quantityClass).append(variantQuantity);
                                    $(availableClass).append(variantAvailable);
                                    var variantPrevPrice = $(totalPriceClass).text().replace('$', '').replace(',', '');
                                    var unitVariantPrice =  cartItems.local_var_price * cartItems.local_var_qty;
                                    var variantTotal = (parseFloat(variantPrevPrice) + parseFloat(unitVariantPrice)).toFixed(2);
                                    var variantTotalPrice = new Intl.NumberFormat('us-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(variantTotal);
                                    $(totalPriceClass).html('$' + variantTotalPrice);
                                }
                                if (cartItems.local_loc_id == 96170017071) {
                                    //  Display the cart HTML on your page
                                    var priceClass = '#cart_alabama #cartItems .items_price.' + cartItems.loc_product_id;
                                    var quantityClass = '#cart_alabama #cartItems .items_qty.' + cartItems.loc_product_id;
                                    var availableClass = '#cart_alabama #cartItems .items_available.' + cartItems.loc_product_id;
                                    var totalPriceClass = '#cart_alabama #cartItems .sub-total_price.' + cartItems.loc_product_id;
                                    $(priceClass).append(variantPrice);
                                    $(quantityClass).append(variantQuantity);
                                    $(availableClass).append(variantAvailable);

                                    var variantPrevPrice = $(totalPriceClass).text().replace('$', '').replace(',', '');
                                    var unitVariantPrice =  cartItems.local_var_price * cartItems.local_var_qty;
                                    var variantTotal = (parseFloat(variantPrevPrice) + parseFloat(unitVariantPrice)).toFixed(2);
                                    var variantTotalPrice = new Intl.NumberFormat('us-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(variantTotal);
                                    $(totalPriceClass).html('$' + variantTotalPrice);
                                }
                                flag = 1;
                            }
                        }
                    }
                    if(flag == 0){
                        if (cartItems.local_loc_id == 96169984303) {
                            //  Display the cart HTML on your page
                            $('#cart_california #cartItems').append(cartHTML1);
                            $('#cart_california').css('display', 'flex');                    
                        }
                        if (cartItems.local_loc_id == 96170017071) {
                            //  Display the cart HTML on your page
                            $('#cart_alabama #cartItems').append(cartHTML1);
                            $('#cart_alabama').css('display', 'flex');                    
                        }
                    }
                    var productAdded = {
                        'product_id': cartItems.loc_product_id,
                        'location_id': cartItems.local_loc_id
                    }
                    appendProducts.push(productAdded);
                });
            
                updateCartTotal();
            }else{
                $('.empty_loc_cart').show();
            }
        }
    });     

    function updateCartTotal() {
        var total_cart = 0;
        $("#cart_california  .sub-total_price").each(function() {
            var sub_total = $(this).text().replace('$', '').replace(',', '');                    
            total_cart += parseFloat(sub_total);
        });
      
        $('#cart_california .summary__total--order-total .price, #cart_california .summary__total--order-payable .price').text('$' + new Intl.NumberFormat('us-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(total_cart));

        var total_cart1 = 0;
        $("#cart_alabama .items_subtotal .sub-total_price").each(function() {
            var sub_total = $(this).text().replace('$', '').replace(',', '');                
            total_cart1 += parseFloat(sub_total);
        });       
        $('#cart_alabama .summary__total--order-total .price, #cart_alabama .summary__total--order-payable .price').text('$' + new Intl.NumberFormat('us-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(total_cart1));
    }

    //cart function to update the quantity on addition
    $(document).on("click", ".add", function(e) {
        var variantSubTotal = 0;
        if (parseInt($(this).prev().val()) < parseInt($(this).prev().attr('max'))) {
            $(this).prev().val(+$(this).prev().val() + 1);
            $(this).parents('li').find('.items_qty .variant_quantity').each(function() { 
                var variantQyt = $(this).find('.quantity-input_cart').val();
                var variantPrice = $(this).find('.quantity-input_cart').attr('data-varaintprice');
                variantSubTotal = variantSubTotal + (parseFloat(variantPrice) * parseInt(variantQyt));
            });

            var sub_total_multiple_price = variantSubTotal.toFixed(2);
            var sub_total_multiple = new Intl.NumberFormat('us-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(sub_total_multiple_price);
            $(this).parents('li').find('.items_subtotal .sub-total_price').html('$' + sub_total_multiple);
            var update_product_id = $(this).prev().attr('data-varaintid');
            var update_location_id = $(this).parents('li').attr('data-location_id');
            var updated_qty = $(this).prev().val();
            updateLocalStorageQuantity(update_product_id, update_location_id, updated_qty);
        } else{
            $(this).parents('.qty_selector').find('.multiple_error').hide();
            $(this).parents('.qty_selector').find('.error_input_iventory').show(); 
            $(this).parents('.qty_selector').find('.max_error').show(); 
            $(this).parents('.qty_selector').find('.error_input_iventory').delay(3000).fadeOut(200);
            $(this).val($(this).prev().attr('max'));
            
            $(this).parents('li').find('.items_qty .variant_quantity').each(function() { 
                var variantQyt = $(this).find('.quantity-input_cart').val();
                var variantPrice = $(this).find('.quantity-input_cart').attr('data-varaintprice');
                variantSubTotal = variantSubTotal + (parseFloat(variantPrice) * parseInt(variantQyt));
            });

            var sub_total_multiple_price = variantSubTotal.toFixed(2);
            var sub_total_multiple = new Intl.NumberFormat('us-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(sub_total_multiple_price);
            
            $(this).parents('li').find('.items_subtotal .sub-total_price').html('$' + sub_total_multiple);

            var update_product_id = $(this).prev().attr('data-varaintid');
            var update_location_id = $(this).parents('li').attr('data-location_id');
            var updated_qty = $(this).val();                       
            updateLocalStorageQuantity(update_product_id, update_location_id, updated_qty);
        }
        updateCartTotal();
    });     

    //cart function to update the quantity on substraction
    $(document).on("click", ".sub", function(e) {
        var variantSubTotal  = 0;
        if (parseInt($(this).next().val()) > 1){
            $(this).next().val(+$(this).next().val() - 1);
            $(this).parents('li').find('.items_qty .variant_quantity').each(function() { 
                var variantQyt = $(this).find('.quantity-input_cart').val();
                var variantPrice = $(this).find('.quantity-input_cart').attr('data-varaintprice');
                variantSubTotal = variantSubTotal + (parseFloat(variantPrice) * parseInt(variantQyt));
            });

            var sub_total_multiple_price = variantSubTotal.toFixed(2);
            var sub_total_multiple = new Intl.NumberFormat('us-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(sub_total_multiple_price);        
            $(this).parents('li').find('.items_subtotal .sub-total_price').html('$' + sub_total_multiple);
            var update_product_id = $(this).next().attr('data-varaintid');
            var update_location_id = $(this).parents('li').attr('data-location_id');
            var updated_qty = $(this).next().val();
            updateLocalStorageQuantity(update_product_id, update_location_id, updated_qty);
        } else{
            $(this).parents('.qty_selector').find('.multiple_error').show();
            $(this).parents('.qty_selector').find('.error_input_iventory').show(); 
            $(this).parents('.qty_selector').find('.max_error').hide(); 
            $(this).parents('.qty_selector').find('.error_input_iventory').delay(3000).fadeOut(200);
        }
        updateCartTotal();
    });

    //cart function to update the quantity using manual digits  
    $(document).on("change", ".quantity-input_cart", function(e){     
        var qty_old = $(this).val();   
        var variantSubTotal  = 0;
        if (parseInt($(this).val()) <= parseInt($(this).attr('max'))) {
            $(this).val(+$(this).val());
            $(this).parents('li').find('.items_qty .variant_quantity').each(function() { 
                var variantQyt = $(this).find('.quantity-input_cart').val();
                var variantPrice = $(this).find('.quantity-input_cart').attr('data-varaintprice');
                variantSubTotal = variantSubTotal + (parseFloat(variantPrice) * parseInt(variantQyt));
            });

            var sub_total_multiple_price = variantSubTotal.toFixed(2);
            var sub_total_multiple = new Intl.NumberFormat('us-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(sub_total_multiple_price);
            $(this).parents('li').find('.items_subtotal .sub-total_price').html('$' + sub_total_multiple);
            var update_product_id = $(this).attr('data-varaintid');
            var update_location_id = $(this).parents('li').attr('data-location_id');
            var updated_qty = $(this).val();
            updateLocalStorageQuantity(update_product_id, update_location_id, updated_qty);
        }else{
           
            $(this).parents('.qty_selector').find('.multiple_error').hide();
            $(this).parents('.qty_selector').find('.error_input_iventory').show(); 
            $(this).parents('.qty_selector').find('.max_error').show(); 
            $(this).parents('.qty_selector').find('.error_input_iventory').delay(3000).fadeOut(200);
            $(this).val($(this).attr('max'));
                
            $(this).parents('li').find('.items_qty .variant_quantity').each(function() { 
                var variantQyt = $(this).find('.quantity-input_cart').val();
                var variantPrice = $(this).find('.quantity-input_cart').attr('data-varaintprice');
                variantSubTotal = variantSubTotal + (parseFloat(variantPrice) * parseInt(variantQyt));
            });
            
            var sub_total_multiple_price = variantSubTotal.toFixed(2);
            var sub_total_multiple = new Intl.NumberFormat('us-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(sub_total_multiple_price);
            $(this).parents('li').find('.items_subtotal .sub-total_price').html('$' + sub_total_multiple);
            var update_product_id = $(this).attr('data-varaintid');
            var update_location_id = $(this).parents('li').attr('data-location_id');
            var updated_qty = $(this).val();
            updateLocalStorageQuantity(update_product_id, update_location_id, updated_qty);
        }
        updateCartTotal();
    });

    // Function to update local storage quantity based on product and location ID
    function updateLocalStorageQuantity(locProductId, localLocId, newQty) {
        var storedDataString = localStorage.getItem('selected_variant_detail');
        var storedDataArray = storedDataString ? JSON.parse(storedDataString) : [];

        // Update quantity in the stored data array
        storedDataArray.forEach(function(item) {
            if (item.local_var_id == locProductId && item.local_loc_id == localLocId) {
                item.local_var_qty = newQty;
            }
        });

        // Save the updated data back to local storage
        localStorage.setItem('selected_variant_detail', JSON.stringify(storedDataArray));
        
        updateCartCount();
    }
  
    $(document).on("click", ".remove_item", function(e) {
        var remove_product_id = $(this).prev('.qty_selector').find('.quantity-input_cart').attr('data-varaintid');
        var remove_location_id = $(this).parents('li').attr('data-location_id');
        removeLocalStorageItem(remove_product_id, remove_location_id);
        location.reload();
    });

    // Function to remove local storage item based on product and location ID
    function removeLocalStorageItem(locProductId, localLocId) {
        var storedDataString = localStorage.getItem('selected_variant_detail');
        var storedDataArray = storedDataString ? JSON.parse(storedDataString) : [];

        // Filter out the item to be removed
        var updatedDataArray = storedDataArray.filter(function(item) {
            return !(item.local_var_id == locProductId && item.local_loc_id == localLocId);
        });

        // Save the updated data back to local storage
        localStorage.setItem('selected_variant_detail', JSON.stringify(updatedDataArray));

        // Check the updated data in the console
        var updatedDataString = localStorage.getItem('selected_variant_detail');

        updateCartCount();       
    }

    var california_po_number = localStorage.getItem('california_po_number'); 
    var checkout_california_in_progress = localStorage.getItem('checkout_california_in_progress'); 
	$(".purchase_limit_error").hide();
   $(".free_sampple_limit_error").hide();
    if(california_po_number != null && checkout_california_in_progress == "true"){
        $('#cart_california  #po_number').val(california_po_number);
    } 
    
    function updateCACart () {
        var items = [];
		var total_quantity = 0;
        // Collect product IDs from data attributes
		 var emp_limit_left = localStorage.getItem('emp_limit_left'); 
       var get_quantity_threshold = localStorage.getItem('quantity_threshold'); 
       var is_employee = localStorage.getItem('is_employee'); 

       var sales_limit_left = localStorage.getItem('sales_limit_left'); 
       var get_sales_quantity_threshold = localStorage.getItem('sales_quantity_threshold'); 
       var is_salesteam = localStorage.getItem('is_salesteam'); 
      
      var free_sample = localStorage.getItem('free_sample'); 
        $('#cart_california #cartItems li .items_qty .variant_quantity').each(function() {
            var productId = $(this).find('.quantity-input_cart').attr('data-varaintid');
            var quantity = $(this).find('.quantity-input_cart').val();
			total_quantity = parseInt(total_quantity) + parseInt(quantity);
            if (quantity > 0) {
                items.push({
                    id: productId,
                    quantity: quantity,
                    properties: {'Location': 'California'}
                });
            }
        });

		if(free_sample == 72 && total_quantity > 72)
        {
          
          $(".free_sampple_limit_error").show();
          window.scrollTo({
            top: 0,
            behavior: 'smooth'
          });
          // Perform Ajax request to add products to cart
        const cartNote = $('#cart_california  #special_instructions').val();
        const po_number = $('#cart_california  #po_number').val();

        $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: {
                items: items,
                note: cartNote,
                attributes: {
                    "P.O. Number": po_number,
                    "Location": "California"
                }
            },
            dataType: 'json',
            success: function(data) {                
                //localStorage.setItem("CheckoutLocation", "CA");             
                //window.location.href = '/checkout';                
            },
            error: function() {
                alert('Error adding products to the cart.');
            }
        });
          
         return false;  
        }else if(total_quantity > emp_limit_left && is_employee == 1 && get_quantity_threshold != null)
        {
          $(".purchase_limit_error").show();
          window.scrollTo({
            top: 0,
            behavior: 'smooth'
          });
          // Perform Ajax request to add products to cart
        const cartNote = $('#cart_california  #special_instructions').val();
        const po_number = $('#cart_california  #po_number').val();

        $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: {
                items: items,
                note: cartNote,
                attributes: {
                    "P.O. Number": po_number,
                    "Location": "California"
                }
            },
            dataType: 'json',
            success: function(data) {                
                //localStorage.setItem("CheckoutLocation", "CA");             
                //window.location.href = '/checkout';                
            },
            error: function() {
                alert('Error adding products to the cart.');
            }
        });
          
         return false;  
        }else if(total_quantity > sales_limit_left && is_salesteam == 1 && get_sales_quantity_threshold != null)
        {
          $(".purchase_limit_error").show();
          window.scrollTo({
            top: 0,
            behavior: 'smooth'
          });
          // Perform Ajax request to add products to cart
        const cartNote = $('#cart_california  #special_instructions').val();
        const po_number = $('#cart_california  #po_number').val();

        $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: {
                items: items,
                note: cartNote,
                attributes: {
                    "P.O. Number": po_number,
                    "Location": "California"
                }
            },
            dataType: 'json',
            success: function(data) {                
                //localStorage.setItem("CheckoutLocation", "CA");             
                //window.location.href = '/checkout';                
            },
            error: function() {
                alert('Error adding products to the cart.');
            }
        });
          
         return false;  
        }else{
           $(".purchase_limit_error").hide();
        

        // Perform Ajax request to add products to cart
        const cartNote = $('#cart_california  #special_instructions').val();
        const po_number = $('#cart_california  #po_number').val();

        $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: {
                items: items,
                note: cartNote,
                attributes: {
                    "P.O. Number": po_number,
                    "Location": "California"
                }
            },
            dataType: 'json',
            success: function(data) {                
                localStorage.setItem("CheckoutLocation", "CA");             
                window.location.href = '/checkout';                
            },
            error: function() {
                alert('Error adding products to the cart.');
            }
        });
		}
    }

    $('#Checkout_California').on('click', function() {  
        const po_number = $('#cart_california  #po_number').val();
        var total_cart_qty = 0;
        $("#cart_california .quantity-input_cart").each(function() {
            var cart_qty = $(this).val();       
            total_cart_qty += parseFloat(cart_qty);
        });
        var mini_cart_value = $(this).attr("data-mini_cart");
        var selected_payment = $("#cart_california .payment_custom_options");
        var selected_payment_type = $(this).parents('.cart-special-container').find('input:checked').val();

        if(selected_payment.length == 1){
            if(po_number != '' && total_cart_qty >= mini_cart_value && selected_payment_type != "" && selected_payment_type != undefined){
                $('#cart_california  #po_number').css('border', '1px solid #757575');
                $('#cart_california  #po_number').next('.error').hide();
                    $.ajax({
                    type: "POST",
                    url: '/cart/clear.js',
                    success: function(){
                        updateCACart ();
                        localStorage.removeItem("checkout_alabama_in_progress");
                        localStorage.setItem("checkout_california_in_progress", "true");
                        localStorage.setItem("california_po_number", po_number);
                    },
                    dataType: 'json'
                });  
            } else if(total_cart_qty < mini_cart_value){
                alert('Minimum California cart quantity is '+ mini_cart_value);
            } else if(po_number == ''){
                // Scroll to the input element
                $('html, body').animate({
                    scrollTop: $('#cart_california  #po_number').offset().top - 200
                }, 1000);

                // Focus on the input element
                $('#cart_california  #po_number').focus();
                $('#cart_california  #po_number').css('border', '1px solid #cb2020');
                $('#cart_california  #po_number:focus-visible').css('outline', 'none');
                $('#cart_california  #po_number').next('.error').show();
            } else {
                $("#Checkout_California").addClass("disableButton");
                $('#cart_california .warningValidation').addClass("showIt");
            } 
        }else{
            if(po_number != '' && total_cart_qty >= mini_cart_value){
                $('#cart_california  #po_number').css('border', '1px solid #757575');
                $('#cart_california  #po_number').next('.error').hide();
                    $.ajax({
                    type: "POST",
                    url: '/cart/clear.js',
                    success: function(){
                        updateCACart ();
                        localStorage.removeItem("checkout_alabama_in_progress");
                        localStorage.setItem("checkout_california_in_progress", "true");
                        localStorage.setItem("california_po_number", po_number);
                    },
                    dataType: 'json'
                });  
            } else if(total_cart_qty < mini_cart_value){
                alert('Minimum California cart quantity is '+ mini_cart_value);
            } else if(po_number == ''){
                // Scroll to the input element
                $('html, body').animate({
                    scrollTop: $('#cart_california  #po_number').offset().top - 200
                }, 1000);

                // Focus on the input element
                $('#cart_california  #po_number').focus();
                $('#cart_california  #po_number').css('border', '1px solid #cb2020');
                $('#cart_california  #po_number:focus-visible').css('outline', 'none');
                $('#cart_california  #po_number').next('.error').show();
            }
        }
            
    });

    $("#cart_california  #po_number").keyup(function(){
        $('#cart_california  #po_number').css('border', '1px solid #757575');
        $('#cart_california  #po_number').next('.error').hide();
    });

    var alabama_po_number = localStorage.getItem('alabama_po_number');
    var checkout_alabama_in_progress = localStorage.getItem('checkout_alabama_in_progress'); 
    if(alabama_po_number != null && checkout_alabama_in_progress == "true"){
        $('#cart_alabama  #po_number_alabama').val(alabama_po_number);
    }

    function updateALCart () {
        var items = [];
         var total_quantity = 0;
        // Collect product IDs from data attributes
        var emp_limit_left = localStorage.getItem('emp_limit_left'); 
       var get_quantity_threshold = localStorage.getItem('quantity_threshold'); 
       var is_employee = localStorage.getItem('is_employee'); 

       var sales_limit_left = localStorage.getItem('sales_limit_left'); 
       var get_sales_quantity_threshold = localStorage.getItem('sales_quantity_threshold'); 
       var is_salesteam = localStorage.getItem('is_salesteam'); 
      
       var free_sample = localStorage.getItem('free_sample'); 
        $('#cart_alabama #cartItems li .items_qty .variant_quantity').each(function() {
            var productId = $(this).find('.quantity-input_cart').attr('data-varaintid');
            var quantity = $(this).find('.quantity-input_cart').val();
             total_quantity = parseInt(total_quantity) + parseInt(quantity);
            if (quantity > 0) {
                items.push({
                    id: productId,
                    quantity: quantity,
                    properties: {'Location': 'Alabama'}
                });
            }
        });

        if(free_sample == 72 && total_quantity > 72)
        {
           $(".free_sampple_limit_error").show();
          window.scrollTo({
            top: 0,
            behavior: 'smooth'
          });
          // Perform Ajax request to add products to cart
        const cartNote = $('#cart_alabama  #special_instructions_alabama').val();
        const po_number = $('#cart_alabama  #po_number_alabama').val();
        $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: {
                items: items,
                note: cartNote,
                attributes: {
                    "P.O. Number": po_number,
                    "Location": "Alabama"
                }
            },
            dataType: 'json',
            success: function() {
                //localStorage.setItem("CheckoutLocation", "AL"); 
               // window.location.href = '/checkout';
            },
            error: function() {
                alert('Error adding products to the cart.');
            }
        });
         return false;  
        } else if(total_quantity > emp_limit_left && is_employee == 1 && get_quantity_threshold != null)
        {
          $(".purchase_limit_error").show();
          window.scrollTo({
            top: 0,
            behavior: 'smooth'
          });
          // Perform Ajax request to add products to cart
        const cartNote = $('#cart_alabama  #special_instructions_alabama').val();
        const po_number = $('#cart_alabama  #po_number_alabama').val();
        $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: {
                items: items,
                note: cartNote,
                attributes: {
                    "P.O. Number": po_number,
                    "Location": "Alabama"
                }
            },
            dataType: 'json',
            success: function() {
                //localStorage.setItem("CheckoutLocation", "AL"); 
               // window.location.href = '/checkout';
            },
            error: function() {
                alert('Error adding products to the cart.');
            }
        });
         return false;  
        }else if(total_quantity > sales_limit_left && is_salesteam == 1 && get_sales_quantity_threshold != null)
        {
          $(".purchase_limit_error").show();
          window.scrollTo({
            top: 0,
            behavior: 'smooth'
          });
          // Perform Ajax request to add products to cart
        const cartNote = $('#cart_alabama  #special_instructions_alabama').val();
        const po_number = $('#cart_alabama  #po_number_alabama').val();
        $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: {
                items: items,
                note: cartNote,
                attributes: {
                    "P.O. Number": po_number,
                    "Location": "Alabama"
                }
            },
            dataType: 'json',
            success: function() {
                //localStorage.setItem("CheckoutLocation", "AL"); 
               // window.location.href = '/checkout';
            },
            error: function() {
                alert('Error adding products to the cart.');
            }
        });
         return false;  
        }else{
           $(".purchase_limit_error").hide();
           $(".free_sampple_limit_error").hide();
        
        // Perform Ajax request to add products to cart
        const cartNote = $('#cart_alabama  #special_instructions_alabama').val();
        const po_number = $('#cart_alabama  #po_number_alabama').val();
        $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: {
                items: items,
                note: cartNote,
                attributes: {
                    "P.O. Number": po_number,
                    "Location": "Alabama"
                }
            },
            dataType: 'json',
            success: function() {
                localStorage.setItem("CheckoutLocation", "AL"); 
                window.location.href = '/checkout';
            },
            error: function() {
                alert('Error adding products to the cart.');
            }
        });
		}
    }

    $('#Checkout_Alabama').on('click', function() {
        const po_number = $('#cart_alabama  #po_number_alabama').val();
        var total_cart_qty = 0;
        $("#cart_alabama .quantity-input_cart").each(function() {
            var cart_qty = $(this).val();       
            total_cart_qty += parseFloat(cart_qty);
        });
        var mini_cart_value = $(this).attr("data-mini_cart");
        var selected_payment = $("#cart_alabama .payment_custom_options");
        var selected_payment_type = $(this).parents('.cart-special-container').find('input:checked').val();

        if(selected_payment.length == 1){
            if(po_number != '' && total_cart_qty >= mini_cart_value && selected_payment_type != "" && selected_payment_type != undefined){
                $('#cart_alabama  #po_number_alabama').css('border', '1px solid #757575');
                $('#cart_alabama  #po_number_alabama').next('.error').hide();
                $.ajax({
                    type: "POST",
                    url: '/cart/clear.js',
                    success: function(){
                        updateALCart ();
                        localStorage.removeItem("checkout_california_in_progress");
                        localStorage.setItem("checkout_alabama_in_progress", "true");
                        localStorage.setItem("alabama_po_number", po_number);
                    },
                    dataType: 'json'
                }); 
            } else if(total_cart_qty < mini_cart_value){
                alert('Minimum Alabama cart quantity is '+ mini_cart_value);
            } else if(po_number == ''){
                // Scroll to the input element
                $('html, body').animate({
                scrollTop: $('#cart_alabama  #po_number_alabama').offset().top - 200
                }, 1000);

                // Focus on the input element
                $('#cart_alabama  #po_number_alabama').focus();
                $('#cart_alabama  #po_number_alabama').css('border', '1px solid #cb2020');
                $('#cart_alabama  #po_number_alabama:focus-visible').css('outline', 'none');
                $('#cart_alabama  #po_number_alabama').next('.error').show();
            }else {
                $("#Checkout_Alabama").addClass("disableButton");
                $('#cart_alabama .warningValidation').addClass("showIt");
            }
        }else{
            if(po_number != '' && total_cart_qty >= mini_cart_value){
                $('#cart_alabama  #po_number_alabama').css('border', '1px solid #757575');
                $('#cart_alabama  #po_number_alabama').next('.error').hide();
                $.ajax({
                    type: "POST",
                    url: '/cart/clear.js',
                    success: function(){
                        updateALCart ();
                        localStorage.removeItem("checkout_california_in_progress");
                        localStorage.setItem("checkout_alabama_in_progress", "true");
                        localStorage.setItem("alabama_po_number", po_number);
                    },
                    dataType: 'json'
                }); 
            } else if(total_cart_qty < mini_cart_value){
                alert('Minimum Alabama cart quantity is '+ mini_cart_value);
            } else if(po_number == ''){
                // Scroll to the input element
                $('html, body').animate({
                scrollTop: $('#cart_alabama  #po_number_alabama').offset().top - 200
                }, 1000);

                // Focus on the input element
                $('#cart_alabama  #po_number_alabama').focus();
                $('#cart_alabama  #po_number_alabama').css('border', '1px solid #cb2020');
                $('#cart_alabama  #po_number_alabama:focus-visible').css('outline', 'none');
                $('#cart_alabama  #po_number_alabama').next('.error').show();
            }
        }

        
    });

    $("#cart_alabama  #po_number_alabama").keyup(function(){
        $('#cart_alabama  #po_number_alabama').css('border', '1px solid #757575');
        $('#cart_alabama  #po_number_alabama').next('.error').hide();
    });

    var alabamaModal = document.getElementById("alabamaCartDelConfirmModal");    
    $('#alabamaCartDelConfirmModal .del-confirm-close').on('click', function() {        
         alabamaModal.style.display = "none";    
    });
    window.onclick = function(event) {
        if (event.target == alabamaModal) {
            alabamaModal.style.display = "none";
        }
    }
   $('.alabama_clear_cart').on('click', function() {        
        alabamaModal.style.display = "block";    
    });
    $('#alabamaCartDelConfirmModal .del-confirm-modal-content .btnCancel').on('click', function() {        
        alabamaModal.style.display = "none";    
    });
  
    $('#alabamaCartDelConfirmModal .del-confirm-modal-content .btnOK').on('click', function() {
        var removeLocationID = $(".alabama_clear_cart").parent().attr('data-warehouse_id');
        removeWarehouseItems(removeLocationID);
        location.reload();      
    });

    var californiaModal = document.getElementById("californiaCartDelConfirmModal");    
    $('#californiaCartDelConfirmModal .del-confirm-close').on('click', function() {        
         californiaModal.style.display = "none";    
    });
    window.onclick = function(event) {
        if (event.target == californiaModal) {
            californiaModal.style.display = "none";
        }
    }
   $('.california_clear_cart').on('click', function() {        
        californiaModal.style.display = "block";    
    });
    $('#californiaCartDelConfirmModal .del-confirm-modal-content .btnCancel').on('click', function() {        
        californiaModal.style.display = "none";    
    });
  
    $('#californiaCartDelConfirmModal .del-confirm-modal-content .btnOK').on('click', function() {
        var removeLocationID = $(".california_clear_cart").parent().attr('data-warehouse_id');
        removeWarehouseItems(removeLocationID);
        location.reload();      
    });

    // Function to remove local storage item based on product and location ID
    function removeWarehouseItems(warehouseId) {
        
        var storedDataString = localStorage.getItem('selected_variant_detail');
        var storedDataArray = storedDataString ? JSON.parse(storedDataString) : [];
        // Filter out the item to be removed
        var updatedDataArray = storedDataArray.filter(function(item) {
            return !(item.local_loc_id == warehouseId);
        });

        // Save the updated data back to local storage
        localStorage.setItem('selected_variant_detail', JSON.stringify(updatedDataArray));

        // Check the updated data in the console
        var updatedDataString = localStorage.getItem('selected_variant_detail');
        if(updatedDataString.length <= 2){
            $.ajax({
                type: "POST",
                url: '/cart/clear.js',
                success: function(){
                    localStorage.removeItem("selected_variant_detail");
                    localStorage.removeItem("checkout_alabama_in_progress");
                    localStorage.removeItem("checkout_alabama_in_progress");
                    localStorage.removeItem("alabama_po_number");
                    localStorage.removeItem("checkout_california_in_progress");
                    localStorage.removeItem("checkout_california_in_progress");
                    localStorage.removeItem("california_po_number");
                    location.reload();
                },
                dataType: 'json'
            }); 
        }
        updateCartCount();       
    }

    $(document).on("click",".meta_color_swatch_item",function() {
        $(".meta_color_swatch_item").removeClass('active_color');
        var color_img_url = $(this).data('color_imgurl');   
        $(this).addClass('active_color');
        $(this).parents('.product-card').find('.product-card__figure img.product-card__image').attr('src' , color_img_url);
        $(this).parents('.product-card').find('.product-card__figure img.product-card__image').attr('srcset' , color_img_url);
    });

    $(document).on("click",".collection__facets .color_group_title",function() {     
        var current_color_group = $(this).attr('class').split('color_toggle_')[1].split(' ')[0];         
        $(".group-list-val .color_opt_"+current_color_group).toggle();
        $(this).toggleClass('active_color_group');
    }); 
   
    $(document).ready(function() {
        var swatch_color_name = $('.product-info__title').attr("data-color");
        $('.selected_color_swatch').html(swatch_color_name);
        $(".Product_swatch_colors .swatch-option.mainColor").first().addClass('active-color');
    });
    
    $(document).on("click", ".Product_swatch_colors .swatch-option", function() {
        var product_handle_selected = $(this).attr('data-product_handle');
        var swatch_color_name = $(this).find('.swatch-option_name').attr("data-color");  
        $('.selected_color_swatch').html(swatch_color_name);
        $('.Product_swatch_colors .swatch-option').removeClass('active-color');
        $(".Product_swatch_colors .swatch-option[data-product_handle = " + product_handle_selected + "]").addClass('active-color');

        $.ajax({
            type: 'GET',
            url: '/products/' + product_handle_selected +'?section=main-product',
            success: function(data) {
                var gallery_content = $(data).find('product-gallery').html();
                // Append the fetched content to the container
                $('product-gallery').html(gallery_content);
            },
            error: function(error) {
                console.error('Error fetching section content:', error);
            }
        });
    });

    $(document).on("click", ".product-gallery__thumbnail", function() {
        var thumbnail_url = $(this).find('img').attr('src');       
        $('.product-gallery__thumbnail').attr('aria-current', "false");
        $(this).attr('aria-current', "true");
        $('.product-gallery__ar-wrapper .product-gallery__media:first-child img').attr('src', thumbnail_url);
        $('.product-gallery__ar-wrapper .product-gallery__media:first-child img').attr('srcset', thumbnail_url);
    });

    $(document).on("click", ".show_future_stock_california", function() {
        $(this).toggleClass('active_stock');
        var current = $(this);
        $(this).parents('.related_pro_item').find('.location_title[data-location_title=california] .future_stock_dates').toggleClass('active_dates');
        $(this).parents('.related_pro_item').find('.qty_main_califonia  .future_stock').toggle();
        $(this).parents('.related_pro_item').find(".meta_product_inventory").each(function() {
            var variant_title = $(this).attr('data-variant_title');
            var location_id = $(this).attr('data-variant_location_id');           
        });
        var input_height = $(this).parents('.related_pro_item').find(".qty_main_califonia  .meta_product_inventory").outerHeight();
       
        $(this).parents('.related_pro_item').find(".location_califonia_subtotal").toggleClass('future_stock_Selected');
        $(this).parents('.related_pro_item').find(".location_califonia_subtotal").css('height', 'auto');
        $(this).parents('.related_pro_item').find(".location_califonia_subtotal.future_stock_Selected").css('height', input_height + 'px');
    });
    $(document).on("click", ".show_future_stock_alabama", function() {
        $(this).toggleClass('active_stock');
        $(this).parents('.related_pro_item').find(".location_califonia_subtotal").toggleClass('alabama_open');
        if (!$(this).parents('.related_pro_item').find(".location_califonia_subtotal").hasClass("future_stock_Selected")) {
            $(this).parents('.related_pro_item').find(".location_alabma_subtotal").addClass('alabama_open_active');
        } else {
            $(this).parents('.related_pro_item').find(".location_alabma_subtotal").removeClass('alabama_open_active');
        }
        var current = $(this);
        $(this).parents('.related_pro_item').find('.location_title[data-location_title=alabama] .future_stock_dates').toggleClass('active_dates');
        $(this).parents('.related_pro_item').find('.qty_main_alabama .future_stock').toggle();
        $(this).parents('.related_pro_item').find(".meta_product_inventory").each(function() {
            var variant_title = $(this).attr('data-variant_title');
            var location_id = $(this).attr('data-variant_location_id');           
        });
        var input_height = $(this).parents('.related_pro_item').find(".qty_main_alabama  .meta_product_inventory").outerHeight() - 40;
       
        $(this).parents('.related_pro_item').find(".location_alabma_subtotal").toggleClass('future_stock_Selected');
        $(this).parents('.related_pro_item').find(".location_alabma_subtotal").css('height', 'auto');
        $(this).parents('.related_pro_item').find(".location_alabma_subtotal.future_stock_Selected").css('height', input_height + 'px');
    });
    
    // Hide color dropdown when click outside
    var targetDiv = $('#allColors');

    // Attach a click event listener to the document body
    $(document).on('click', function(event) {
        // Check if the click event target is not the target div or its descendants 
       if (!targetDiv.is(event.target) && targetDiv.has(event.target).length === 0) {
            // If clicked outside of the target div, hide the div
            $('#colorDropdown').hide();
        }
    });

    // Optionally, you can prevent propagation of the click event within the target div
    targetDiv.on('click', function(event) {
        event.stopPropagation();
    });

    // Function to convert date format
    function convertToUSDateFormat(dateString) {
        var parts = dateString.split('/');
        return parts[1] + '/' + parts[0] + '/' + parts[2];
    }
  
    // sort future stock dates
    function sortDates(datesArr){
        var dates = [];
        dates = datesArr;

        // Convert each date in the array
        var convertedDates = dates;

        // Convert date strings to Date objects
        var dateObjects = convertedDates.map(function(dateString) {
            return new Date(dateString);
        });

        // Sort Date objects
        dateObjects.sort(function(a, b) {
            return a - b;
        });

        // Format sorted Date objects back to strings
        var sortedDates_cal = dateObjects.map(function(dateObject) {
            var options = { year: 'numeric', month: '2-digit', day: '2-digit' };
            return new Intl.DateTimeFormat('en-US', options).format(dateObject);
        });

        return sortedDates_cal ;
    }

    $(document).on("click", ".swatch-more", function(e) {
        $(this).prevAll(".meta_color_swatch_item").removeClass("hide_swatch_color");
        $(this).addClass("hide_more_color");
    }); 

    async function updatePrices(unique_product_handle){
    var getPricing = await fetch('https://www.nextlevelapparel.com/products/' + unique_product_handle + '.json')
        .then(response => response.json())
        .then(data => 
            $.each(data.product.variants, function(index, value){
                $(".variant_detail_items").each(function(index){
                    var current = $(this).attr('data-size');
                    if(value.title == current){
                        $(this).find('.variant_price').text('$ ' + value.price)
                        $(this).attr('data-title-variant', value.title)
                        $(this).attr('data-price-variant', value.price)
                        $(this).attr('data-parent-handle', data.product.handle)
                        var priceClass = '.data-variant-title-' + value.title
                        $(priceClass).attr('data-variant_price', value.price);
                    }
                })
            })
        )
        .catch(error => console.error(error));       
    }


    function updateCartCount() {
        var selected_variant_detail = localStorage.getItem('selected_variant_detail');
        var cartItemDetail = selected_variant_detail ? JSON.parse(selected_variant_detail) : [];
        $('.header__cart-count').html('<span class="count-bubble">'+cartItemDetail.length+'</span>');

    }
    setTimeout(function() {
        updateCartCount();
    }, 1000);
    
});


function hideStickyBar(){
  
$('.Atc_Wrapper.addToCartSticky').hide();

}

// NLAS-54 - Color swatches dropdown

$("ul.custom-dropdown").on("click", ".init", function() {
    $(this).closest("ul.custom-dropdown").children('li:not(.init)').toggle();
});

var allOptions = $("ul.custom-dropdown").children('li:not(.init)');
$("ul.custom-dropdown").on("click", "li:not(.init)", function() {
    allOptions.removeClass('selected');
    $(this).addClass('selected');
    $("ul.custom-dropdown").children('.init').html($(this).html());
    allOptions.toggle();
    var selected_prod_handle = $(this).attr("data-prod_handle");
  $('.Product_swatch_colors div[data-product_handle="'+selected_prod_handle+'"]').trigger('click');
});

var selected_value = $('ul.custom-dropdown li.first-color').html();
 $(".custom-dropdown li:first-child").html(selected_value);
 
$(".Product_swatch_colors .swatch-option").click(function() {
  var selected_product_handle = $(this).attr("data-product_handle");
    var first_li = $('.custom-dropdown li[data-prod_handle="'+selected_product_handle+'"]').html();
  $(".custom-dropdown li:first-child").html(first_li);
  
});

$(document).mouseup(function(event) {

  var target = event.target;
  var custom_dropdown = $(".custom-dropdown");

  if (!custom_dropdown.is(target) && custom_dropdown.has(target).length === 0) {
    $('.custom-dropdown li').hide();
     $('.custom-dropdown li:first').show();
  }

});

// ended NLAS-54 - Color swatches dropdown
// NLAS-54 - Size chart

 $(document).ready(function () {
            $('#openModal').on('click', function () {
                $('#sizeChartModal').css('display', 'flex').hide().fadeIn();
              $('.inventory_table_header').css('z-index', '0');
              $('.shopify-section-group-header-group').css('z-index', '0');
              
               $('.inventory_table_header').css('position', 'static');
                
            });

            $('#closeModal').on('click', function () {
                $('#sizeChartModal').fadeOut();
                $('.inventory_table_header').css('z-index', '7');
                $('.shopify-section-group-header-group').css('z-index', '10');
                  $('.inventory_table_header').css('position', 'sticky');
            });

            $(window).on('click', function (event) {
                if ($(event.target).is('#sizeChartModal')) {
                    $('#sizeChartModal').fadeOut();
                     $('.inventory_table_header').css('z-index', '7');
                    $('.shopify-section-group-header-group').css('z-index', '10');
                     $('.inventory_table_header').css('position', 'sticky');
                  
                }
            });

            // NLAS-99 - Notifyme popup
             
          $(document).on('click', '.notifyme_grid_btn', function () {
             
            var getparentDiv = $(this).closest('.meta_product_inventory');
            var getvariantId = getparentDiv.data('variant-id');
            var getpackQty   = getparentDiv.data('pack-qty');
            var variant_location_id     = getparentDiv.data('variant_location_id');
            var variant_title     = getparentDiv.data('variant_title');
            var get_rowlevel_parentDiv = $(this).closest('.related_pro_item');
            var getColorname = get_rowlevel_parentDiv.find('.product_info_data .text-sm').text().trim();  
            var setproductid     = get_rowlevel_parentDiv.data('product_id');
            var get_image_url = get_rowlevel_parentDiv.find('.product_info_data .productImageWithBadge img').attr('src');   
            var prod_variant_img = '<img src="' + get_image_url + '" alt="' + getColorname + '" width="50%" height="50%" />';
                
             $('#variant_color_name').val(getColorname);
             $('#stock_location_id').val(variant_location_id);
             var locationName = "";
             if(variant_location_id == 96169984303){
             $('#stock_location_name').val("California");   
             locationName = "California";
             }
             if(variant_location_id == 96170017071){
             $('#stock_location_name').val("Alabama");   
             locationName = "Alabama";
             }
             $('#set_productid').val(setproductid);
             $('#variant_size').val(variant_title);
             $('#set_variant_id').val(getvariantId);
             $('.notify_me_product_title').html("Color: "+getColorname+ " - " + variant_title + " - " + locationName);
             $('.notify_me_product_img').html(prod_variant_img);
             $('#notifyme_popup').css('display', 'flex').hide().fadeIn();
             $('.inventory_table_header').css('z-index', '0');
             $('.shopify-section-group-header-group').css('z-index', '0');
             $('.inventory_table_header').css('position', 'static');
                
            });

          $(document).on('click', '.nla-notifyme-modal #closeModal', function () {
                $('#notifyme_popup').fadeOut();
                $('.inventory_table_header').css('z-index', '7');
                $('.shopify-section-group-header-group').css('z-index', '10');
                $('.inventory_table_header').css('position', 'sticky');
                $('#stock_location_id').val("");
                $('#stock_location_name').val("");
                $('#variant_color_name').val("");
                $('#set_productid').val("");
                $('#set_variant_id').val("");
                $('#variant_size').val("");
                $('#popup_result').html("");
            });
            
            $(window).on('click', function (event) {
                if ($(event.target).is('#notifyme_popup')) {
                    $('#notifyme_popup').fadeOut();
                     $('.inventory_table_header').css('z-index', '7');
                    $('.shopify-section-group-header-group').css('z-index', '10');
                     $('.inventory_table_header').css('position', 'sticky');
                  
                }
            });

            // Submit button click event
             $('#popup_submitButton').on('click', function (e) {    
                e.preventDefault();
                $('#popup_result').html("").hide();
                    handlePopupSubmission();
            }); 

            function handlePopupSubmission() {
                const selectedLocation = $('#stock_location_id').val();
                const selectedLocationName = $('#stock_location_name').val();
                const selectedColorName = $('#variant_color_name').val();
                const selectedProductID = $('#set_productid').val();
                const selectedSizeVariantId = $('#set_variant_id').val();
                const selectedSizeName = $('#variant_size').val();
                const emailValue = $('#popupemailInput').val();
                const companyNameValue = $('#popupcompanyName').val();
                const customerIDValue = $('#popupcustomerID').val();
                // Create submission data
                const submissionPopupData = {
                    location_id: selectedLocation,
                    location_name: selectedLocationName,
                    product_id: selectedProductID,
                    color_name: selectedColorName,
                    variant_id: selectedSizeVariantId,
                    size: selectedSizeName,
                    email: emailValue,
                    company_name: companyNameValue,
                    customer_id: customerIDValue,
                    timestamp: new Date().toISOString()
                };

                
          $.ajax({
          type: 'POST',
          url: 'https://nla-locator.nextlevelapparel.com/backinstock/notifyme_api.php',
          data: {
              "notifyme": submissionPopupData
          },
          success: function(data) {
            var dataJson = JSON.parse(data);
             // Show success message
                const resultHTML = dataJson.message;
                if(dataJson.status == 'exist' || dataJson.status == 'failed'){
                    $('#popup_result').css('color','red');
                    $('#popup_result').html(resultHTML).show();
                }else{
                      $('#popup_result').css('color','');
                      $('#popup_result').html(resultHTML).show();
                       // Reset form
                      setTimeout(function(){
                           $("#notifyme_popup").fadeOut();
                            $('#stock_location_id').val("");
                            $('#stock_location_name').val("");
                            $('#variant_color_name').val("");
                            $('#set_productid').val("");
                            $('#set_variant_id').val("");
                            $('#variant_size').val("");
                            $('#popup_result').html("");
                
                        }, 3000);
                }
                
          }
        });
               

               
            }

              // End of NotifyMe work   
        });
        
// NLAS-54 - Ended Size chart

// NLAS-54 - Show more / less

document.addEventListener('DOMContentLoaded', () => {
  const contentWrapper = document.querySelector('.spec-content-wrapper ul');
  const toggleButton = document.querySelector('.moreless-button');
  const productSpec = document.querySelector('.product.info.detailed');

  // Set initial height to 70% of the content
  const fullHeight = productSpec.scrollHeight;
  const initialHeight = fullHeight * 0.3;
  contentWrapper.style.maxHeight = `${initialHeight}px`;
  // Apply a smooth transition effect
  contentWrapper.style.transition = 'max-height 0.5s ease';
  
  toggleButton.addEventListener('click', () => {
    if (contentWrapper.style.maxHeight === `${initialHeight}px`) {
      contentWrapper.style.maxHeight = `${fullHeight}px`; // Expand to full height
      toggleButton.textContent = 'Show Less >>';
    } else {
      contentWrapper.style.maxHeight = `${initialHeight}px`; // Collapse back to 70%
      toggleButton.textContent = 'Show More >>';
    }
  });
});
// NLAS-54 - Ended Show more / less


// NLAS-95 - 

 $(document).ready(function () {
            $('.notifyme-btn').on('click', function () {
              $('.notifyme_form').toggle();
            });
 });

